import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { FaAudible, FaAudioDescription, FaBlog, FaBlogger, FaBullseye, FaCamera, FaCameraRetro, FaChartBar, FaChartLine, FaCheck, FaChevronRight, FaClipboardList, FaHammer, FaImage, FaInfoCircle, FaList, FaListAlt, FaLock, FaMeetup, FaNotesMedical, FaPhoenixFramework, FaPhone, FaPlay, FaPlayCircle, FaPlusCircle, FaProjectDiagram, FaQuestionCircle, FaRegQuestionCircle, FaRegSadTear, FaSadCry, FaSave, FaSearch, FaSpinner, FaTimes, FaTrash, FaTrashAlt, FaTrophy, FaUser, FaUsers, FaVolumeUp, FaWpforms } from "react-icons/fa";
import { FaLink, FaPlus } from "react-icons/fa";
import { BsPlus } from "react-icons/bs";
import Modal from "../components/ui/Modal";
import { toast } from "react-toastify";
import { differenceInDays } from "date-fns";
import NuevoLinkServicioDetailsDialog from "../components/dialogs/NuevoLinkServicioDetailsDialog";
import CalendarSeguimiento from "../components/seguimiento/calendarSeguimiento/CalendarSeguimiento";
import { FaCompass } from "react-icons/fa";
import { FaCalendarCheck } from "react-icons/fa";
import ItemRowTareaProyecto from "../components/seguimiento/ItemRowTareaProyecto";
import MotionNumber from 'motion-number'
import moment, { duration } from 'moment-timezone';
import Tooltip from "../components/ui/ToolTip";
import { FiShare2 } from "react-icons/fi";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import SeguimientoFormularioScreen from "../components/seguimiento/seguimientoFormularios/SeguimientoFormulariosScreen";
import HandleUpdateCheckbox from "../utils/HandleUpdateCheckbox";
import DemoAccessBox from "../components/seguimiento/DemoAccessBox";
import { 
  CaracteristicasAulaVirtual, 
  CaracteristicasAulaVirtualIntermedio, 
  CaracteristicasAulaVirtualBasico, 

  CaracteristicasTiendaVirtual, 
  CaracteristicasTiendaVirtualIntermedio,
  CaracteristicasTiendaVirtualBasico,

  CaracteristicasWebInformativa,
  CaracteristicasWebInformativaIntermedia,
  CaracteristicasWebInformativaBasica,
  CaracteristicasAdicionales,
  CaracteristicasAdicionalesBasico,
  CaracteristicasAdicionalesIntermedio
} from "../utils/plainValues/CaracteristicasServicios";
import LinksReportesAds from "../components/seguimiento/LinksReportesAds";
import CredentialsBox from "../components/seguimiento/CredentialsBox";
import HandleUpdateText from "../utils/HandleUpdateText";
import { LinkProyectoGrabacion } from "../components/seguimiento/LinkProyectoGrabacion";
import { LinksProyectoMakingOf } from "../components/seguimiento/LinksProyectoMakingOf";
import { GetStatusColor, PlanBackgroundColor, statusColorMap } from "../utils/GetTextColor";
import ChecklistServicio from "../components/seguimiento/ChecklistServicio";
import CalendarioSeguimientoTareas from "../components/seguimiento/CalendarioSeguimientoTareas/CalendarioSeguimientoTareas";
import VerifyValidUrl from "../utils/VerifyValidUrl";
import { serviceStatus, webServiceStatus } from "../utils/rawData/serviceStatus";
import SeguimientoLinks from "../components/seguimiento/SeguimientoLinks";
import LlamadasSeguimiento from "../components/seguimiento/LlamadasSeguimiento";
import InputFormValue from "../components/ui/components/InputFormValue";
import ClientData from "../components/seguimiento/uiSeguimiento/ClientData";
import ClientDataModal from "../components/ui/proyectos/ClientDataModal";
import ClientsDataCategories from "../utils/plainValues/ClientsDataCategories";
import { SiGoogledrive } from "react-icons/si";
import SeguimientoActionPanel from "../components/seguimiento/SeguimientoActionPanel";


const SeguimientoDetails = () => {

  const user = useSelector((state) => state.auth.user); // Usuario => IMPORTANTE!
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"

  const { id, activeServices, serviceId } = useParams(); // Extraemos el id, el nombre del servicio y el id del servicio de la URL

  const [formulariosList, setFormulariosList] = useState([]); // Lista de formularios (?)
  const [linksList, setLinksList] = useState([]); // Lista de links (?)
  const [nuevoLinkOpen, setNuevoLinkOpen] = useState(false);

  const [tasks, setTasks] = useState([])
  const [objectives, setObjectives] = useState([])
  const [phases, setPhases] = useState([])

  const firstMeetingWithClient = tasks.filter((t) => t.isMeeting === true)[0]?.id

  const [personalInvolved, setPersonalInvolved] = useState([]) // Personal involucrado en al menos 1 de las tareas del servicio

  const [userStatus, setUserStatus] = useState("");

  const [isProcessGenerationLoading, setIsProcessGenerationLoading] = useState(false)
  const [loadingText, setLoadingText] = useState("")

  const [activeModalTrabajadores, setActiveModalTrabajadores] = useState(false);
  const [trabajadoresAddVList, setTrabajadoresAddList] = useState([]);

  const tasksCompleted = tasks.filter((task) => task.delivered === true) // Al fin y al cabo, "Finalizado" y "Con retraso" implican lo mismo

  const fetchProcesses = async () => {
    try {

  //////////////////////// Modelo 2 ////////////////////////// Pedir los datos dependiendo del nivel anterior Fase > Objetivo > Tarea  ====> DEPRECATED

      // const phases = await axios.get(`${BACKEND}/api/fasesProyectos?where[service][equals]=65778502c1c6ac85e69c8b72&limit=0`)
      // const phasesIds = phases.filter((phase => {phase.id}))
      // const objectives = await axios.get(`${BACKEND}/api/objetivosProyectos?where[phase][in]=${phasesIds}&limit=0`);
      // const objectivesIds = objectives.filter((objective => {objective.id}))
      // const tasks = await axios.get(`${BACKEND}/api/tareasProyectos?where[objective][in]=${objectivesIds}&limit=0`);

  //////////////////////// Modelo 1 ////////////////////////// Pedir los datos por separado, según el ID del servicio
      const tasks = await axios.get(`${BACKEND}/api/tareasProyectos?where[objective.phase.service][equals]=${serviceId}&limit=0&depth=3`)

      const objectives = await axios.get(`${BACKEND}/api/objetivosProyectos?where[phase.service][equals]=${serviceId}&limit=0`)

      const phases = await axios.get(`${BACKEND}/api/fasesProyectos?where[service][equals]=${serviceId}&limit=0`)

      setTasks(tasks.data.docs)
      setObjectives(objectives.data.docs)
      setPhases(phases.data.docs)

    } catch (error) {
      toast.error("Error obteniendo las fases del proyecto: " + error)
    }
  }

  const successChildUpdate  = async (text) => { // Funcion que actualiza el componente padre cuando se hace un cambio en lso componentes hijos
    await fetchProcesses()
    setLoadingText("")
  }

  // Funciones para el ordenamiento y agrupación de los procesos

  const extractNumberFromName = (str) => { // Función para extraer el número después de "TWA", "Objetivo" o "Fase"
    if (!str || typeof str !== 'string') return 0;
    const match = str.match(/(?:TGAD|TLP|TSTV|TDOM|HOST|TCFC|TMCR|TMA|TSW|TMET|TWI|TAV|TWC|TUXI|TCAF|SV|Objetivo|Fase)\s*(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1], 10) : 0;
  };

  const sortPhases = (phases) => { // Ordenar fases de menor a mayor según el número
    return phases.sort((a, b) => extractNumberFromName(a.phase.name) - extractNumberFromName(b.phase.name));
  };

  const sortObjectives = (objectives) => { // Ordenar objetivos de menor a mayor según el número
    return objectives.sort((a, b) => extractNumberFromName(a.objective.name) - extractNumberFromName(b.objective.name));
  };

  const sortTasks = (tasks) => { // Ordenar tareas de menor a mayor según el número
    return tasks.sort((a, b) => extractNumberFromName(a.task.name) - extractNumberFromName(b.task.name));
  };

  // Agrupar las tareas, objetivos y fases
  const groupPhasesObjectivesTasks = (phases, objectives, tasks) => {
    const sortedPhases = sortPhases(phases);
    const sortedObjectives = sortObjectives(objectives);
    const sortedTasks = sortTasks(tasks);

    return sortedPhases.map(phase => ({
      id: phase.id,
      name: phase.phase.name,
      deliverDate: phase.deliverDate,
      objetivos: sortedObjectives
        .filter(obj => obj.phase.id === phase.id) // Filtrar los objetivos que pertenecen a esta fase
        .map(obj => ({
          id: obj.id,
          name: obj.objective.name,
          tareas: sortedTasks
            .filter(task => task.objective.id === obj.id) // Filtrar las tareas que pertenecen a este objetivo
            .map(task => ({
              id: task.id,
              name: task.task.name,
              status: task.status,
              responsible: task.responsible,
              startDate: task.startDate,
              limitDate: task.limitDate,
              deliverDate: task.deliverDate,
              delivered: task.delivered,
              locked: task.locked,
              isProofNeeded: task.isProofNeeded,
              isVisit: task.isVisit,
              isMeeting: task.isMeeting,
              proofMedia: task.proofMedia,
              links: task.links,
              audios: task.audios,
              deliverHistorical: task.deliverHistorical,
              label: task.label,
              score: task.score,
              defaultScoreAssignedTo: task.defaultScoreAssignedTo,
              taskEvents: task.taskEvents,
              serviceId: task.serviceId
            })),
        })),
    }));
  };

  const groupedData = groupPhasesObjectivesTasks(phases, objectives, tasks) // Data agrupada

  //================================== Fases =========================================

  const [trabajadoresList, setTrabajadoresList] = useState([]); // Lista de trabajadores

  const [integrantesList, setIntegrantesList] = useState([]); // Lista de integrantes

  const [servicioData, setServicioData] = useState(null); // Data del servicio general

  // Modal de datos del cliente (reutiliza el mismo modal que en Proyectos*)
  const [openModalClientData, setOpenModalClientData] = useState(false); // estado modal
  const [selectedClientData, setSelectedClientData] = useState(null); // servicio/cliente seleccionado

  const tabs = [ // Tabs del menú
    { id: 1, name: "General", value: "General", icon: FaCompass, show: true },
    { id: 2, name: "Fases", value: "Fases", icon: FaProjectDiagram, show: true },
    { id: 3, name: "Tracking", value: "Tracking", icon: FaChartBar, show: true },
    { id: 4, name: "Encuestas", value: "Encuestas", icon: FaListAlt, show: true },
    { id: 5, name: "Calendario", value: "Calendario", icon: FaCalendarCheck, show: true },
    { id: 6, name: "Llamadas", value: "Llamadas", icon: FaPhone, show: true },
  ];

  const [activeTab, setActiveTab] = useState(tabs[1]); // Tab activo

  const [formValues, setFormValues] = useState({ // Metadatos del servicio
    estado: "Por comenzar",
    audiovisuales: "no",

    presupuesto: 0,
    gastado: 0,
    fechaInicio: "",
    fechaFin: "",
    fechaRenovacion: "",
    fechaLanzamiento: ""
  });

  const fetchServicioDetails = async () => {
    if (id) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/serviciosCotizaciones/${serviceId}?depth=3` // Se obtienen los detalles del servicio
        );

        setServicioData(response.data);
        setRelevantLinks(response.data.relevantLinks || [])
        setAssociatedServices(response.data.associatedServices || [])
        setSelectedCharacteristics(response.data.caracteristicas || [])
        setIntegrantesList(
          response.data?.integrantes ? response.data?.integrantes : [] // Si hay integrantes del servicio 
        );

        if (response.data.estado) {
          setFormValues((prev) => ({ ...prev, estado: response.data.estado }));
        }

        if (response.data.audiovisuales) {
          setFormValues((prev) => ({
            ...prev,
            audiovisuales: response.data.audiovisuales,
          }));
        }

        if (response.data.presupuesto) {
          setFormValues((prev) => ({
            ...prev,
            presupuesto: response.data.presupuesto,
          }));
        }

        if (response.data.gastado) {
          setFormValues((prev) => ({
            ...prev,
            gastado: response.data.gastado,
          }));
        }

        if (response.data.fechaInicio) {
          setFormValues((prev) => ({
            ...prev,
            fechaInicio: response.data.fechaInicio.split("T")[0],
          }));
        }

        if (response.data.fechaFin) {
          setFormValues((prev) => ({
            ...prev,
            fechaFin: response.data.fechaFin.split("T")[0],
          }));
        }

        if (response.data.fechaLanzamiento) {
          setFormValues((prev) => ({
            ...prev,
            fechaLanzamiento: response.data.fechaLanzamiento
          }));
        }

        if (response.data.fechaRenovacion) {
          setFormValues((prev) => ({
            ...prev,
            fechaRenovacion: response.data.fechaRenovacion
          }));
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchLinksServicios = async () => {
    if (user) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/linksServicioCotizaciones?where[servicioCotizacion][equals]=${id}`
        );
        setLinksList(response.data.docs);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchTrabajadores = async () => {
    if (user) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/trabajadores?limit=1000&depth=2`
        );
        setTrabajadoresList(response.data.docs);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Formulario

  const asignarFormulario = async (tipo) => {
    try {
      const respuestasFormulariosServicio = await axios.get(
        `${BACKEND}/api/formularioServicio?where[servicio][equals]=${servicioData?.servicio?.id}&where[tipo][equals]=${tipo}`
      );
      if (respuestasFormulariosServicio.data?.docs.length === 0) {
        toast.warning(`No existe formualrios de ${tipo} para este servicio`);
        return;
      } else {
        await axios.post(`${BACKEND}/api/formularioServicioRespuestas`, {
          formulario: respuestasFormulariosServicio.data.docs[0].id,
          servicioCotizacion: serviceId,
        });
        await fetchFormulariosRespuestas();
        toast.success("Se ha asignado este formulario al cliente");
      }
    } catch (error) {
      toast.error("Hubo un problema al registrar");
    }
  };

  const eliminarFormulario = async (idFormulario) => {
    if (!window.confirm("Seguro de eliminar este formulario")) {
      return;
    }
    try {
      const respuestasFormulariosServicio = await axios.delete(
        `${BACKEND}/api/formularioServicioRespuestas/${idFormulario}`
      );
      toast.success("Formulario eliminado");
      await fetchFormulariosRespuestas();
    } catch (error) {
      toast.error("Se elimino este formulario");
    }
  };

  const fetchFormulariosRespuestas = async () => {
    if (user) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/formularioServicioRespuestas?where[servicioCotizacion][equals]=${serviceId}`
        );
        setFormulariosList(response.data.docs);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const updateServicio = async () => {
    if (user) {
      try {
        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
          estado: formValues.estado,

          fechaInicio: formValues.fechaInicio,
          fechaFin: formValues.fechaFin,
          fechaLanzamiento: formValues.fechaLanzamiento,
          fechaRenovacion: formValues.fechaRenovacion,

          audiovisuales: formValues.audiovisuales,
          presupuesto: formValues.presupuesto,
          gastado: formValues.gastado,
        });
        toast.success("Actualizado");
      } catch (error) {
        toast.error("No se pudo actualizar: " + error)
      }
    }
  };

  // Interacción con los procesos, generarlos y eliminarlos

  const [selectedTemplate, setSelectedTemplate] = useState("")
  const [templateModalActive, setTemplateModalActive] = useState(false)

  const generateProcess = async () => {
    try {
      setIsProcessGenerationLoading(true)
      setLoadingText("Creando proceso, espera porfavor...")
      await axios.post(`${BACKEND}/api/processMiddleware/generateProcess`, {
          serviceName: selectedTemplate,
          serviceId: serviceId
      })
      successChildUpdate()
      toast.success("Proceso generado con éxito")
    } catch (error) {
      toast.error("Error generando el proceso: " + error.response.data.message)
    } finally {
      setIsProcessGenerationLoading(false)
    }
  }

  const deleteProcess = async () => {
    const confirmed = window.confirm("Seguro desea eliminar este proceso?")
    if (confirmed) {  
      setLoadingText("Eliminando proceso, espera porfavor...")
      try {
        await axios.post(`${BACKEND}/api/processMiddleware/eliminateProcess`, {
          serviceId: serviceId
        })
        successChildUpdate()
        toast.success("Proceso eliminado con éxito")
      } catch (error) {
        toast.error("Error eliminando el proceso: " + error)
      }
    }
  }

  // Funciones chetas 

  const getBackgroundColorForPercentage = (percentage) => { // Obtener el background-color
    if (percentage === 100) return 'bg-green-500'; // Verde oscuro
    if (percentage >= 87.5) return 'bg-green-400'; // Verde más claro
    if (percentage >= 75) return 'bg-green-300'; // Verde aún más claro
    if (percentage >= 62.5) return 'bg-yellow-400'; // Amarillo
    if (percentage >= 50) return 'bg-yellow-300'; // Amarillo más claro
    if (percentage >= 37.5) return 'bg-orange-400'; // Naranja
    if (percentage >= 25) return 'bg-orange-300'; // Naranja más claro
    if (percentage >= 12.5) return 'bg-red-600'; // Rojo
    return 'bg-red-800'; // Rojo más claro
  };

  const getTextColorForPercentage = (percentage) => {// Obtener el text color
    if (percentage === 100) return 'text-green-500'; // Verde oscuro
    if (percentage >= 87.5) return 'text-green-400'; // Verde más claro
    if (percentage >= 75) return 'text-green-300'; // Verde aún más claro
    if (percentage >= 62.5) return 'text-yellow-400'; // Amarillo
    if (percentage >= 50) return 'text-yellow-300'; // Amarillo más claro
    if (percentage >= 37.5) return 'text-orange-400'; // Naranja
    if (percentage >= 25) return 'text-orange-300'; // Naranja más claro
    if (percentage >= 12.5) return 'text-red-600'; // Rojo
    return 'text-red-800'; // Rojo más claro
  };
  
  const calculatePercentage = (value1, value2) => { // Calcular el porcentaje entre 2 valores
    if (value2 === 0) return 0; 
    return (value1 / value2) * 100;
  };

  const countCompleted = (phases) => { // Calcular los objetivos y las fases completadas
    let completedPhases = 0;
    let completedObjectives = 0;
  
    phases.forEach((fase) => {
      let completedPhase = true; // Asumimos que la fase está completa hasta que se demuestre lo contrario
  
      fase.objetivos.forEach((objetivo) => {
        // Comprobar si todas las tareas del objetivo están finalizadas
        const objectiveCompleted = objetivo.tareas.every(tarea => tarea.delivered === true);
        
        if (objectiveCompleted) {
          completedObjectives++; // Contamos el objetivo como completado
        } else {
          completedPhase = false; // Si un objetivo no está completado, la fase no puede estar completada
        }
      });
  
      if (completedPhase) {
        completedPhases++; // Si todos los objetivos de la fase están completados, contamos la fase
      }
    });
  
    return {
      completedPhases,
      completedObjectives
    };
  };

  function capitalizeWords(str) {
    if (!str) return ''; // Verifica si la cadena es undefined o null, y devuelve una cadena vacía
    return str
      .split(' ') // Divide la cadena en palabras separadas por espacios
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza la primera letra y convierte el resto en minúsculas
      .join(' '); // Vuelve a unir las palabras en una sola cadena
  };

  useEffect(() => {
    if (user) {
      const puesto = user.puesto.toUpperCase();

      if (
        puesto === "JEFE DE CMS" ||
        puesto === "JEFE DE CODE" ||
        puesto === "JEFE DE AUDIOVISUALES" ||
        puesto.includes("ESPECIALISTA") ||
        servicioData?.responsable?.id === user.id
      ) {
        setUserStatus("Admin");
      } else if (puesto === "GERENTE GENERAL" || puesto === "JEFE DE MARKETING" || puesto === "JEFE DE PROYECTOS" || puesto === "ASISTENTE" || puesto === "ADMINISTRADOR") {
        setUserStatus("SuperAdmin");
      } else {
        setUserStatus("Member");
      }
    }
  }, [servicioData]);

  useEffect(() => {
    fetchServicioDetails();
    fetchTrabajadores();
    fetchFormulariosRespuestas();
    fetchLinksServicios();
    fetchProcesses()
  }, []);

  useEffect(() => {
    const workersInvolved = tasks.reduce((acc, task) => {
      if (task.responsible && !acc.some(worker => worker.id === task.responsible.id)) {
        acc.push(task.responsible); // Agregar solo si no está en la lista
      }
      return acc;
    }, []);

    setPersonalInvolved(workersInvolved); // Actualizar el estado con la lista de trabajadores

  }, [tasks]);

  const count = countCompleted(groupedData); // Devuelve un objeto con los objetivos y las fases completadas

  const completedObjectives = count.completedObjectives
  const completedPhases = count.completedPhases

  const percentajeCompleted = calculatePercentage(tasksCompleted.length, tasks.length) // Porcentaje de tareas completadas
  const backgroundColorClass = getBackgroundColorForPercentage(percentajeCompleted); // Clase de color de fondo
  const textColorClass = getTextColorForPercentage(percentajeCompleted); // Clase de color de texto

  //////////////////////////////////////// Sección de la creacion de nuevas tareas, objetivos y fases //////////////////////////////////////////////////////////////

  const [newTaskModal, setNewTaskModal] = useState(false)
  const [newObjectiveModal, setNewObjectiveModal] = useState(false)
  const [newPhaseModal, setNewPhaseModal] = useState(false)

  ///////////////////////////////////// Seccion de tareas /////////////////////////////////////

  const [taskFormValues, setTaskFormValues] = useState({ // Valores del formulario de nueva tarea
    name: "",
    objective: null,
    objectiveName: null,
    responsible: user.id,
    serviceId: serviceId,
    isProofNeeded: false
  })

  const resetTaskFormValues = () => { // Restear los campos de taskFormValues
    setTaskFormValues({
      name: "",
      objective: null,
      objectiveName: null,
      responsible: "",
      serviceId: serviceId
    })
  }

  const [filteredTextTasks, setFilteredTextTasks] = useState([]);

  const handleTaskChange = (e) => { // Cambio de tareas
    const { name, value } = e.target;
    const newValue = value;
    setTaskFormValues({
        ...taskFormValues,
        [name]: newValue,
    });

    // "Reutilizar" tareas
    if (taskFormValues.name.length >= 2) {
      const filtered = tasks.filter((task) =>
        task.task.name.toLowerCase().includes(taskFormValues.name.toLowerCase())
      );
      setFilteredTextTasks(filtered);
    } else {
      setFilteredTextTasks([]); // Limpiar cuando tiene menos de 4 caracteres
    }
  };

  const handleTaskSubmit = async (e) => { // Crear tarea
    e.preventDefault()
    try {
      const responseTask = await axios.post(`${BACKEND}/api/tareas`, {
        name: taskFormValues.name,
        defaultObjective: null,
        defaultService: null,
        defaultResponsible: null,
        isProofNeeded: taskFormValues.isProofNeeded,
        isVisit: taskFormValues.isVisit,
        isMeeting: taskFormValues.isMeeting
      })

      await axios.post(`${BACKEND}/api/tareasProyectos`, {
        task: responseTask.data.doc.id,
        objective: taskFormValues.objective,
        responsible: taskFormValues.responsible,
        serviceId: serviceId,
        isProofNeeded: taskFormValues.isProofNeeded,
        isVisit: taskFormValues.isVisit,
        isMeeting: taskFormValues.isMeeting,
        links: [],
        audios: []
      })

      setNewTaskModal(false)
      resetTaskFormValues()
      successChildUpdate()
      toast.success("Tarea creada exitosamente")
    } catch (error) {
      toast.error("Error al crear la tarea: " + error)
    }
  }

  ///////////////////////////////////// Seccion de objetivos /////////////////////////////////////

  const [objectiveFormValues, setObjectiveFormValues] = useState({ // Valores del formulario de nuevo objetivo
    objective: "",
    phase: null,
    phaseName: null
  })

  const resetObjectiveFormValues = () => { // Resetear los campos de objectiveFormValues
    setObjectiveFormValues({
      objective: "",
      phase: null,
      phaseName: null
    })
  }

  const handleObjectiveChange = async (e) => { // Cambio de objetivos
    const { name, value } = e.target;
    const newValue = value;
    setObjectiveFormValues({
        ...objectiveFormValues,
        [name]: newValue,
    });
  }

  const handleObjectiveSubmit = async (e) => { // Crear objetivo
    e.preventDefault()
    try {
      const responseObjective = await axios.post(`${BACKEND}/api/objetivos`, {
        name: objectiveFormValues.objective,
        defaultPhase: null,
        defaultService: null
      })

      await axios.post(`${BACKEND}/api/objetivosProyectos`, {
        objective: responseObjective.data.doc.id,
        phase: objectiveFormValues.phase
      })
      setNewObjectiveModal(false)
      resetObjectiveFormValues()
      successChildUpdate()
      toast.success("Objetivo creado exitosamente")
    } catch (error) {
      toast.error("Error al crear el objetivo: " + error)
    }
  }

  ///////////////////////////////////// Seccion de fases ///////////////////////////////////// POR TESTEAR EL LUNES

  const [phaseFormValues, setPhaseFormValues] = useState({
    name: "",
    deliverDate: ""
  })

  const resetPhaseFormValues = () => {
    setPhaseFormValues({
      name: "",
      defaultDuration: ""
    })
  }

  const handlePhaseChange = async (e) => {
    const { name, value } = e.target;
    const newValue = value;
    setPhaseFormValues({
      ...phaseFormValues,
      [name]: newValue
    })
  }

  const handlePhaseSubmit = async (e) => {
    e.preventDefault()
    try {
      const responsePhase = await axios.post(`${BACKEND}/api/fases`, {
        name: phaseFormValues.name,
        defaultService: null,
        defaultDuration: null
      })
      
      const response2 = await axios.post(`${BACKEND}/api/fasesProyectos`, {
        phase: responsePhase.data.doc.id,
        deliverDate: phaseFormValues.deliverDate,
        service: serviceId
      })

      setNewPhaseModal(false)
      resetPhaseFormValues()
      successChildUpdate()
      toast.success("Fase creada exitosamente")
    } catch (error) {
      console.log(error)
      toast.error("Error al crear la fase: " + error)
    }
  }

  // Templates o plantillas

  const [templates, setTemplates] = useState([])

  const getTemplates = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/fases?limit=0`)
      const templatesFromDB = response.data.docs.map(item => item.defaultService)
      setTemplates([...new Set(templatesFromDB)])
    } catch (error) {
      toast.error("Error obteniendo las plantillas: " + error)
    }
  }

  useEffect(() => {
    getTemplates()
  }, [])

  // Funcion para "reutilizar" tareas

  const [typeNewTask, setNewTypeTask] = useState("Existing")

  const [selectedTaskText, setSelectedTaskText] = useState(false)

  useEffect(() => {
    if (taskFormValues.name.length === 0) {
      setSelectedTaskText(false)
    }
  }, [taskFormValues.name])

  // Cambiar responsable
  
  const [serviceResponsibleInitialStatus, setServiceResponsibleInitialStatus] = useState(servicioData?.responsable)
  const [serviceResponsible, setServiceResponsible] = useState(servicioData?.responsable)

  const changeServiceResponsible = async () => {
    if (serviceResponsible !== serviceResponsibleInitialStatus) {
      try {
        const responsibleId = serviceResponsible ? serviceResponsible?.id : null
        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
          responsable: responsibleId
        })
        successChildUpdate()
      } catch (error) {
        toast.error("Error actualizando el responsable: " + error)
      }
    }
  }

  useEffect(() => {
    changeServiceResponsible()
  }, [serviceResponsible])

  useEffect(() => {
    if (servicioData?.responsable) {
      setServiceResponsible(servicioData.responsable);
    }
  }, [servicioData]);

  // Etiquetas

  // Estado para las etiquetas
  const [labels, setLabels] = useState([]);

  useEffect(() => { // Contador de tareas en cada etiqueta

    const taskCountByLabel = sortTasks(tasks).reduce((acc, task) => {
      acc[task.label] = (acc[task.label] || 0) + 1;
      return acc;
    }, {});

    const uniqueTasks = [
      ...new Map(
        sortTasks(tasks).map(task => [
          task.label,
          {
            label: task.label,
            responsible: task.responsible,
            count: taskCountByLabel[task.label],
          }
        ])
      ).values()
    ];

    setLabels(uniqueTasks);
  }, [tasks]);

  const handleResponsibleChange = async (e, label) => {
    const selectedTrabajador = trabajadoresList.find(t => t.id === e.target.value);
  
    if (!selectedTrabajador) return; // Verificar si se seleccionó un trabajador válido
  
    const filteredTasks = tasks.filter(task => task.label === label);
  
    setLabels(prevLabels =>
      prevLabels.map(task =>
        task.label === label
          ? { ...task, responsible: selectedTrabajador }
          : task
      )
    );
  
    const updatedTasks = filteredTasks.map(task => ({
      ...task,
      responsible: selectedTrabajador.id,
    }));
  
    try {
      await Promise.all(
        updatedTasks.map(task =>
          axios.put(`${BACKEND}/api/tareasProyectos/${task.id}`, {
            responsible: selectedTrabajador.id
          })
        )
      );
      
      toast.success(`${updatedTasks.length} tareas actualizadas correctamente`)
      successChildUpdate()
  
    } catch (error) {
      toast.error("Error al actualizar las tareas: " +  error);
    }
  };

  // Servicios asociados

  const [associateServicesModal, setAssociateServicesModal] = useState(false)

  const [associatedServices, setAssociatedServices] = useState([])

  const addAssociatedService = () => {
    if (associatedServices.length < 10) {
      setAssociatedServices([...associatedServices, { serviceId: "" }]); // Cambio: Se usa 'serviceId' correctamente
    }
  };

  const handleAssociatedServiceIdChange = (index, event) => {
    const newServices = [...associatedServices];
    newServices[index] = { serviceId: event.target.value }; // Asegúrate de actualizar 'serviceId'
    setAssociatedServices(newServices);
  };

  const removeAssociatedService = (index) => {
    const newServices = associatedServices.filter((_, i) => i !== index); 
    setAssociatedServices(newServices);
  };

  const updateAssociatedServices = async () => {
    try {

      const brandsIdsToSend = [...associatedServices.map(service => service.serviceId)]

      brandsIdsToSend.push(servicioData.id)

      const response = await axios.put(`${BACKEND}/api/processMiddleware/associateServices`, {
        brandsIds: brandsIdsToSend
      })

      toast.success("Servicios asociados actualizados correctamente")
      fetchServicioDetails()
    } catch (error) {
      console.log(error)
      toast.error("Error al actualizar los servicios asociados: " + error)
    }
  }
  
  //////////////////// Ordenamientos  ////////////////////

  // Criterios de ordenamiento: "Etiqueta", "Tarea", "Responsable", "Objetivo", "Fase", "Puntaje", "Puntaje asignado", "Estado"
  // Criterios de filtro: "Etiqueta", "Responsable", "Objetivo", "Fase", "Estado", "Reunión", "Visita AV", "Visible cliente", "Puntaje", "Puntaje asignado"

  const [taskOrderCriteria, setTaskOrderCriteria] = useState("Tarea")
  const [taskFilteringCriteria, setTaskFilteringCriteria] = useState("Responsable")
  const [taskFilter, setTaskFilter] = useState(isAdmin ? "Todos" : user.name)

  const [filterAv, setFilterAv] = useState(false)
  const [filterMeets, setFilterMeets] = useState(false)

  const sortTasksTab = (tasks, criteria) => {

    switch (criteria) {
        case "Tarea":
            return tasks.sort((a, b) => {
              const taskA = a.task?.task?.name || '';
              const taskB = b.task?.task?.name || '';
              return extractNumberFromName(taskA) - extractNumberFromName(taskB)
          });
        case "Etiqueta":
            return tasks.sort((a, b) => a?.label?.localeCompare(b?.label));
        case "Responsable":
            return tasks.sort((a, b) => a.responsible?.name.localeCompare(b.responsible?.name));
        case "Objetivo":
            return tasks.sort((a, b) => {
                const objectiveA = a.objective?.objective?.name || '';
                const objectiveB = b.objective?.objective?.name || '';
                return extractNumberFromName(objectiveA) - extractNumberFromName(objectiveB);
            });
        case "Fase":
            return tasks.sort((a, b) => a.objective?.phase?.phase?.name.localeCompare(b.objective?.phase?.phase?.name));
        case "Puntaje":
            return tasks.sort((a, b) => b.score - a.score); // Ordenar de mayor a menor
        case "Puntaje asignado":
            return tasks.sort((a, b) => a.defaultScoreAssignedTo?.name.localeCompare(b.defaultScoreAssignedTo?.name));
        case "Estado":
            const statusOrder = ['Pendiente', 'En proceso', 'Finalizado', 'Con retraso', 'Incumplido', 'Eliminado'];
            return tasks.sort((a, b) => statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status));
        default:
            return tasks;
    }
  };

  const uniqueLabels = tasks.reduce((acc, task) => {
    if (task.label && !acc.includes(task.label)) {
      acc.push(task.label);
    }
    return acc;
  }, []);

  const uniqueObjectives = objectives.reduce((acc, objective) => {
    if (objective.objective.name && !acc.includes(objective.objective.name)) {
      acc.push(objective.objective.name)
    }
    return acc
  }, [])

  const uniquePhases = phases.reduce((acc, phase) => {
    if (phase.phase.name && !acc.includes(phase.phase.name)) {
      acc.push(phase.phase.name)
    }
    return acc
  }, [])

  const workersOnCurrentService = tasks.reduce((acc, task) => {
    if (task.responsible?.name && !acc.includes(task.responsible?.name)) {
      acc.push(task.responsible?.name)
    }
    return acc
  }, [])
  
  const filterOptions = {
    Etiqueta: uniqueLabels,
    Responsable: workersOnCurrentService,
    Objetivo: uniqueObjectives,
    Fase: uniquePhases,
    Estado: ["Pendiente", "En proceso", "Finalizado", "Con retraso", "Incumplido", "Eliminado"],
    Reunion: ["Si", "No"],
    "Visita AV": ["Si", "No"],
    "Visible cliente": ["Sí", "No"],
    Puntaje: [5, 4, 3, 2, 1, 0, -1, -2, -3, -4, -5],
    "Puntaje asignado": trabajadoresList
  };



  /// Modo simple y sus ordanmeinttos y filtros
  const [simpleMode, setSimpleMode] = useState(true) // Modo simple, esto deja de mostrar la vista de tareas con objetivos y fases

  const [hideFinished, setHideFinished] = useState(false) // Este estado deja de mostrar las tareas finalizadas
  const [hidePending, setHidePending] = useState(false) // Este estado deja de mostrar las tareas pendientes
  
  const orderedTasks = sortTasksTab([...tasks], taskOrderCriteria)

  // Función para filtrar las tareas según el criterio y valor de filtro
  const getFilteredTasks = () => {
    // Filtramos las tareas por los criterios de filtro seleccionados
    let tasksToRender = orderedTasks;

    // Aplicar filtros adicionales fuera del switch
    if (filterMeets) {
      tasksToRender = tasksToRender.filter((task) => task.isMeeting === filterMeets);
    }

    if (filterAv) {
      tasksToRender = tasksToRender.filter((task) => task.isVisit === filterAv);
    }
  
    if (taskFilteringCriteria !== "Todos" && taskFilter !== "Todos") {
      tasksToRender = tasksToRender.filter((task) => {
        switch (taskFilteringCriteria) {
          case "Etiqueta":
            return task.label === taskFilter;
          case "Responsable":
            return task.responsible?.name === taskFilter;
          case "Objetivo":
            return task.objective?.objective?.name === taskFilter;
          case "Fase":
            return task.objective?.phase?.phase?.name === taskFilter;
          case "Estado":
            return task.status === taskFilter;
          case "Visible cliente":
            return task.visibleToClient ? "Sí" === taskFilter : "No" === taskFilter;
          case "Puntaje":
            return task.score === parseInt(taskFilter, 10);
          case "Puntaje asignado":
            return task.defaultScoreAssignedTo?.id === taskFilter;
          default:
            return true;
        }
      });
    }
  
    // Si hideFinished está activado, filtramos las tareas completadas
    if (hideFinished) {
      tasksToRender = tasksToRender.filter((task) => !task.delivered);
    }

    if (hidePending) {
      tasksToRender = tasksToRender.filter((task) => task.delivered);
    }
  
    return tasksToRender;
  };
  

  // Tareas filtradas que se van a renderizar
  const filteredTasks = getFilteredTasks();

  // Sección de links
  const [linksModalActive, setLinksModalActive] = useState(false)

  const [relevantLinks, setRelevantLinks] = useState([])

  const handleServiceLinks = (index, event, field) => {
    const newLinks = [...relevantLinks];
    newLinks[index] = {
        ...newLinks[index],
        [field]: event.target.value
    };
    setRelevantLinks(newLinks);
  };

  const removeRelevantLink = (index) => {
    const newLinks = relevantLinks.filter((_, i) => i !== index); 
    setRelevantLinks(newLinks);
  };

  const addServiceLink = () => {
    setRelevantLinks([...relevantLinks, { name: "", link: "" }]);
  };

  const updateRelevantLinks = async () => {
    try {

      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
        relevantLinks: relevantLinks
      })

      toast.success("Links guardados correctamente")
      fetchServicioDetails()
    } catch (error) {
      console.log(error)
      toast.error("Error al guardar los links: " + error)
    }
  }

  // Parsear la descripción para formatearla en una tabla
  
  const parseDescription = (description) => {
    if (!description || typeof description !== "string") {
      return [];
    }
  
    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Si" : value.trim()) : "-",
      };
    });
  };  

  const descriptionText = servicioData?.customDescriptionActive
  ? servicioData?.customDescriptionText
  : servicioData?.servicio?.preciosUnitarios?.find(
      (precioUnit) => precioUnit?.plan?.id === servicioData?.planServicio?.id
    )?.descripcion;

  const parsedDescription = parseDescription(descriptionText);

  // Links redes clientes

  const [activeLinksClientsModal, setActiveLinksClientsModal] = useState(false)
  const [linksNetClients, setLinksNetClients] = useState([])

  const [linkWebOficial, setLinkWebOficial] = useState({ url: "" });
  const [linkDemo, setLinkDemo] = useState({ url: "" });
  const [linkBackup, setLinkBackup] = useState({ url: "" });
  

  const getLinksClients = async () => { // Obtenemos los links de los clientes
    try {
      const response = await axios.get(`${BACKEND}/api/LinksServiciosClientes?limit=0&where[cliente][equals]=${id}&where[servicio][equals]=${servicioData.servicio.id}`)
      setLinksNetClients(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handleSaveLink = async (link, linkTitulo) => { // Guardamos el link

    if (!link.url.startsWith("https://")) {
      toast.warning("El enlace debe comezar con 'https://'")
      return
    }
  
    try {
      const payload = {
        url: link.url,
        ...(link.id ? {} : { titulo: linkTitulo, servicio: servicioData.servicio.id, cliente: id }),
      };
  
      if (link.id) {
        // Actualizar link existente
        await axios.put(`${BACKEND}/api/LinksServiciosClientes/${link.id}`, payload);
        toast.success("Link actualizado con éxito");
      } else {
        // Crear nuevo link
        await axios.post(`${BACKEND}/api/LinksServiciosClientes`, payload);
        toast.success("Link creado con éxito");
      }
  
      // Refrescar la lista de links
      getLinksClients();
    } catch (error) {
      console.error(error);
      toast.error("Error al guardar el link.");
    }
  };

  const handleSaveAdsLinks = async (link, field) => {
    try {
      const response = await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
        [field]: link
      });
      toast.success("Link actualizado con éxito")
    } catch (error) {
      toast.error("Error al actualizar el link")
      console.log(error)
    }
  }
 
  useEffect(() => {
    setLinkWebOficial(
      linksNetClients.find((link) => link.titulo === "Link web oficial") || { url: "" }
    );
    setLinkDemo(
      linksNetClients.find((link) => link.titulo === "Link demo") || { url: "" }
    );
    setLinkBackup(
      linksNetClients.find((link) => link.titulo === "Link backup") || { url: "" }
    );
  }, [linksNetClients]);

  useEffect(() => {
    if (servicioData) {
      getLinksClients()
    }
  }, [servicioData])

  // Información del servicio nueva

  const [refWeb, setRefWeb] = useState(servicioData?.webReferencia) // Referencia web
  const [copyWebRef, setCopyWebRef] = useState(servicioData?.copiaSeguridadReferencia) // Copia de seguridad de la agencia referencia
  const [linkDesarrollo, setLinkDesarrollo] = useState(servicioData?.linkDesarrollo)
  const [linkCapacitacion, setLinkCapacitacion] = useState(servicioData?.linkCapacitacion)

  const [infoComplete, setInfoComplete] = useState(servicioData?.informacionEnviada) // Info completa
  const [capDone, setCapDone] = useState(servicioData?.capacitacionHecha) // Capacitación hecha
  const [delayResponsible, setDelayResponsible] = useState(servicioData?.delayResponsible) // Responsable retraso

  const handleUpdateRefWeb = async (link) => { // Actualizar la web de referencia
    try {

      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
        webReferencia: link
      })
      toast.success("Web de referencia actualizada con éxito")
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateCopyRefWeb = async (link) => { // Actualizar la web de referencia
    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
        copiaSeguridadReferencia: link
      })
      toast.success("Copia  actualizada con éxito")
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateInfoSent = async (status) => { // Actualizar el estado de la información enviada del cliente
    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
        informacionEnviada: status || null
      })
      toast.success("Estado actualizado con éxito")
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateCapDone = async (status) => { // Actualizar el estado de la capacitación al cliente
    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
        capacitacionHecha: status || null
      })
      toast.success("Estado actualizado con éxito")
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateDelayResponsible = async (status) => { // Actualizar el responsable del retraso
    try {
      const response = await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
        delayResponsible: status || null
      })
      toast.success("Responsable actualizado con éxito")
      setServicioData(response.data.doc)
    } catch (error) {
      toast.error("Error al actualizar el responsable del retraso: " + error)
    }
  }

  const handleUpdateLinkCapacitacion = async (link) => {
    try {

      if (link !== "") {
        const verifiedLink = VerifyValidUrl(link)

        if (!verifiedLink) {
          toast.error("El link de capacitación no es válido")
          return
        }

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
          linkCapacitacion: link || null
        })
        toast.success("Estado actualizado con éxito")
      } else {
        // Si el link está vacío, se actualiza a una string vacía
        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
          linkCapacitacion: ""
        })
        toast.success("Estado actualizado con éxito")
      }

    } catch (error) {
      toast.error("Error al actualizar el link de capacitación: " + error)
    }
  }

  ///// Cambiar fechas del proyecto

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setFormValues((prev) => ({
      ...prev,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {
        const changeHistory = servicioData.historialCambios ? [...servicioData.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: servicioData[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicioData.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        setServicioData((prevData) => ({
          ...prevData,
          historialCambios: changeHistory,
        }));

        toast.success("Fecha actualizada con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 2000); // Esperar 2 secs luego de que el usuario deja de ecsribir
  };

  /////////////////// EXPERIMENTO
  const addRegisterTaskEvents = async (taskId) => {
    try {
      // Obtener los datos de la tarea
      const { data: task } = await axios.get(`${BACKEND}/api/tareasProyectos/${taskId}`);
      const taskEvents = Array.isArray(task.taskEvents) ? [...task.taskEvents] : [];
      const lastEvent = taskEvents[taskEvents.length - 1];
  
      // Determinar el nuevo tipo de evento
      const newEventType = lastEvent?.type === "standBy" || lastEvent?.type === undefined ? "inProcess" : "standBy";
      const newEvent = {
        type: newEventType,
        timeStamp: new Date().toISOString(),
      };
  
      // Actualizar el array de eventos
      const updatedTaskEvents = [...taskEvents, newEvent];
  
      // Enviar la actualización al backend
      await axios.put(`${BACKEND}/api/tareasProyectos/${taskId}`, { taskEvents: updatedTaskEvents });
  
      // Actualizar el estado local
      setTasks((prevTasks) =>
        prevTasks.map((t) => (t.id === taskId ? { ...t, taskEvents: updatedTaskEvents } : t))
      );
  
    } catch (error) {
      console.error("Error al añadir el estado:", error);
      toast.error("Error al cambiar el estado de la tarea. Por favor, inténtalo de nuevo.");
    }
  };

  useEffect(() => {
    if (servicioData) {
      setRefWeb(servicioData?.webReferencia || '');
      setCopyWebRef(servicioData?.copiaSeguridadReferencia || '');
      setInfoComplete(servicioData?.informacionEnviada || false);
      setCapDone(servicioData?.capacitacionHecha || false);
      setLinkDesarrollo(servicioData?.linkDesarrollo || '');
      setLinkCapacitacion(servicioData?.linkCapacitacion || '')
      setDelayResponsible(servicioData?.delayResponsible || 'Por definir')
    }
  }, [servicioData]); // Este efecto se ejecutará cada vez que servicioData cambie



  ///////// Características del servicio ///////////////

  const [showAv, setShowAv] = useState(false)
  const [showTv, setShowTv] = useState(false)
  const [showWi, setShowWi] = useState(false)
  const [showAd, setShowAd] = useState(false)

  const [aulaVirtualChars, setAulaVirtualChars] = useState([]);
  const [tiendaVirtualChars, setTiendaVirtualChars] = useState([]);
  const [webInformativaChars, setWebInformativaChars] = useState([]);
  const [adicionalChars, setAdicionalChars] = useState([])
  
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);
  
  useEffect(() => {
    setSelectedCharacteristics([...aulaVirtualChars, ...tiendaVirtualChars, ...webInformativaChars, ...adicionalChars]);
  }, [aulaVirtualChars, tiendaVirtualChars, webInformativaChars, adicionalChars]);
  
  const handlerChangeCharsFilter = (char, checked, category) => {
    if (category === "AulaVirtual") {
      setAulaVirtualChars((prev) =>
        checked ? [...prev, char] : prev.filter((c) => c !== char)
      );
    } else if (category === "TiendaVirtual") {
      setTiendaVirtualChars((prev) =>
        checked ? [...prev, char] : prev.filter((c) => c !== char)
      );
    } else if (category === "WebInformativa") {
      setWebInformativaChars((prev) =>
        checked ? [...prev, char] : prev.filter((c) => c !== char)
      );
    } else if (category === "Adicional") {
      setAdicionalChars((prev) =>
        checked ? [...prev, char] : prev.filter((c) => c !== char)
      );
    }
  };
  
  const handleSelectCategory = (newChars, category) => {
    if (category === "AulaVirtual") {
      setAulaVirtualChars(newChars);
    } else if (category === "TiendaVirtual") {
      setTiendaVirtualChars(newChars);
    } else if (category === "WebInformativa") {
      setWebInformativaChars(newChars);
    } else if (category === "Adicional") {
      setAdicionalChars(newChars)
    }
  };
  
  useEffect(() => {
    if (servicioData) {
      HandleUpdateCheckbox(
        "caracteristicas",
        selectedCharacteristics,
        servicioData.id,
        "serviciosCotizaciones"
      );
    }
  }, [selectedCharacteristics]);

  if (!servicioData) return;

  return (
    <div className="h-screen flex flex-col">

      <Modal // Modal de Links
        activeModal={linksModalActive}
        title={"Links del servicio"}
        onClose={() => setLinksModalActive(false)}
        centered
      >
        <div className="flex flex-col gap-4">

          <div className="flex flex-col gap-4">
            <label htmlFor="associateServicesModal" className="block mb-2 font-bold text-gray-700 text-xs">
                Links: {relevantLinks.length}
            </label>
            <p className="block text-gray-500 text-sm">Aca puedes colocar links relevantes para este servicio (páginas web, meets, etc)</p>
          </div>

          <div className="max-h-[350px] overflow-y-auto gap-2">
            {relevantLinks.length === 0 ? (
              <div className="h-full w-full text-xs flex items-center justify-center text-center text-gray-400 h-[120px] border border-gray-200 rounded-md">
                No hay links guardados
              </div>
            ) : (
              relevantLinks.map((link, index) => (
                <div key={index} className="flex flex-col border rounded-lg p-2 shadow-md gap-2 mb-4">

                    <div className="flex border rounded-lg">
                      <input
                          type="text"
                          value={link.name}
                          placeholder="Nombre o descripción del link"
                          onChange={(event) => handleServiceLinks(index, event, 'name')}
                          className="w-full text-xs border border-white rounded-l-lg px-2 py-2"
                        />
                    </div>

                    <div className="flex border rounded-lg">
                      <input
                          type="text"
                          value={link.link}
                          placeholder="Link"
                          onChange={(event) => handleServiceLinks(index, event, 'link')}
                          className="w-full text-xs border border-white rounded-l-lg px-2 py-2"
                      />
                      <button
                          type="button"
                          onClick={() => removeRelevantLink(index)}
                          className="inline-flex text-xs items-center px-3 text-red-600 bg-red-100 border border-gray-300 hover:bg-red-300 rounded-r-md transition-all duration-100"
                      >
                          <FaTrashAlt />
                      </button>
                    </div>

                </div>
              ))
            )}

          </div>
            <div className="flex flex-col items-center justify-center gap-4 w-full">
              <button
                  type="button"
                  onClick={addServiceLink}
                  className="w-full border text-xs border-gray-300 rounded-lg flex items-center justify-center p-2 text-gray-700 hover:bg-blue-500 hover:bg-opacity-25 transition-all duration-100"
              >
                  <FaPlus className="mr-2" /> Añadir nuevo link
              </button>
    
            <button 
              onClick={() => {
                updateRelevantLinks()
                setLinksModalActive(false)
              }}
              className="w-full text-xs font-bold flex items-center justify-center py-2 gap-2 rounded-md bg-orange-500 font-semibold text-white text-sm"
            >
              <FaSave className="w-7"/>
              Guardar links
            </button>
            </div>
        </div>
        
      </Modal>

      <Modal // Modal para asociar servicos-
        activeModal={associateServicesModal}
        title={"Asociar servicios"}
        onClose={() => setAssociateServicesModal(false)}
        centered
      >
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-4">
              <label htmlFor="associateServicesModal" className="block mb-2 text-xs font-bold text-gray-700">
                  Servicios asociados: {associatedServices.length}
              </label>
              <p className="block text-gray-500 text-xs">Puedes asociar hasta un máximo de 10 servicios</p>
            </div>
            {associatedServices.map((service, index) => (
              <div key={index} className="flex flex-col border text-xs rounded-lg p-2 shadow-md gap-2">

                  <p>
                    {service.serviceName || "N/A"}
                  </p>

                  <div className="flex border rounded-lg">
                    <input
                        type="text"
                        value={service.serviceId}
                        placeholder="Ingrese el id de un servicio..."
                        onChange={(event) => handleAssociatedServiceIdChange(index, event)}
                        className="w-full border text-xs border-white rounded-l-lg px-2 py-2"
                    />
                    <button
                        type="button"
                        onClick={() => removeAssociatedService(index)}
                        className="inline-flex text-xs items-center px-3 text-sm text-red-600 bg-red-100 border border-gray-300 hover:bg-red-300 rounded-r-md transition-all duration-100"
                    >
                        <FaTrashAlt />
                    </button>
                  </div>

              </div>
            ))}
            <div className="flex flex-col items-center justify-center gap-4 w-full">
              {associatedServices?.length < 10 && (
                  <button
                      type="button"
                      onClick={addAssociatedService}
                      className="w-full border text-xs border-gray-300 rounded-lg flex items-center justify-center p-2 mt-2 text-gray-700 hover:bg-blue-500 hover:bg-opacity-25 transition-all duration-100"
                  >
                      <FaPlus className="mr-2" /> Añadir nuevo servicio
                  </button>
              )}
    
            <button 
              onClick={() => {
                updateAssociatedServices()
                setAssociateServicesModal(false)
              }}
              className="w-full flex items-center text-xs font-bold justify-center py-2 gap-2 rounded-md bg-orange-500 text-white text-sm"
            >
              <FaSave className="w-7"/>
              Guardar servicios
            </button>
            </div>
        </div>
      </Modal>

      <Modal // Modal para crear nuevas tareas
          activeModal={newTaskModal}
          title={"Nueva tarea"}
          onClose={() => {
            setNewTaskModal(false)
            resetTaskFormValues()
            setSelectedTaskText(false)
            setFilteredTextTasks([])
          }}
          centered={true}
      >
          <form 
            onSubmit={handleTaskSubmit}
          >

            <div className="mb-4">
              <div className="flex items-center justify-center bg-gray-100 gap-3 mb-2 py-2 px-4 rounded-sm">

                <div className="flex flex-row items-center justify-center gap-2 flex-1 pl-12">
                  <span className="text-gray-700 font-medium text-xs">Tarea nueva</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        id="activeFilter"
                        type="checkbox"
                        checked={typeNewTask === "Existing"}
                        onChange={() => {
                          if (typeNewTask === "New") {
                            setNewTypeTask("Existing");
                            setTaskFormValues(prev => ({
                              ...prev,
                              name: ""
                            }));
                          } else {
                            setNewTypeTask("New");
                            setTaskFormValues(prev => ({
                              ...prev,
                              name: ""
                            }));
                          }
                        }}
                        className="sr-only peer text-xs"
                    />
                    <div className="w-11 h-6 bg-green-500 rounded-full peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 peer-dark:bg-gray-700 peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600"></div>
                  </label>
                  <span className="text-gray-700 font-medium text-xs">Tarea existente</span>
                </div>
                
                <div className="ml-auto">
                  <Tooltip content={
                      <div>
                        <span><span className="font-bold">Tarea nueva:</span> Crea una tarea completamente nueva.</span> <br />
                        <span><span className="font-bold">Tarea existente:</span> Te permite seleccionar y "reutilizar" una tarea ya existente, pero con una fecha y entrega diferentes.</span>
                      </div>
                    }
                  >
                    <div className="hover:cursor-pointer">
                        <FaRegQuestionCircle className="text-black" /> 
                    </div> 
                  </Tooltip>
                </div>

              </div>
            </div>

            <div className="mb-4">
                <label className="block text-gray-700 mb-2 text-xs" htmlFor="objective">
                    Objetivo
                </label>
                <div className="flex">
                  <span className="inline-flex items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaBullseye />
                  </span>
                  <input
                    type="text"
                    id="objective"
                    name="objective"
                    value={taskFormValues.objectiveName}
                    className="rounded-tr-lg text-xs rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full border-gray-300 p-2.5"
                    disabled
                  />
                </div>
            </div>

            <div className="mb-4">
                <label className="block text-gray-700 mb-2 text-xs" htmlFor="name">
                    Nombre de la tarea
                    <span className="text-red-500">*</span> 
                </label>
                <div className="flex relative">
                  <span className={`inline-flex text-xs items-center px-3 ${typeNewTask === "Existing" ? "bg-blue-500" : "bg-green-500"} border rounded-e-0 border-gray-300 border-e-0 rounded-s-md`}>
                    {typeNewTask === "Existing" ? <FaSearch className="text-white"/> : <FaCheck className="text-white"/>}
                  </span>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder={typeNewTask === "Existing" ? "Escribe el nombre de la tarea existente..." : "Ingresa el nombre de la nueva tarea"}
                    value={taskFormValues.name}
                    onChange={handleTaskChange}
                    className="rounded-tr-lg text-xs rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full border-gray-300 p-2.5"
                    required
                  />
                  {typeNewTask === "Existing" && (
                    <button
                      className="text-white absolute end-2.5 top-2 font-xs rounded-md text-xs px-4 py-1 bg-blue-600"
                    >
                      Buscar
                    </button>
                  )}
                </div>

                  {filteredTextTasks.length > 0 && typeNewTask !== "New" && selectedTaskText === false && (
                    <div className="absolute left-6 bg-white border border-gray-300 rounded-md shadow-md max-h-48 w-[92%] overflow-y-auto z-50">
                      {filteredTextTasks.map((task, index) => (
                        <div
                          key={index}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer transition-all duration-100 border-b"
                          onClick={() => {
                            setTaskFormValues({ ...taskFormValues, name: task.task.name, isMeeting: task.isMeeting, isVisit: task.isVisit, responsible: user.id })
                            setSelectedTaskText(true)
                          }}
                        >
                          <span className="text-xs"> {task.task.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
            </div>

            <div className="mb-4">
                <label className="block text-gray-700 mb-2 text-xs" htmlFor="defaultResponsible">
                    Responsable
                </label>
                <div className="flex">
                    <span className="inline-flex items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                      <FaUser />
                    </span>
                    <select
                      id="responsible"
                      name="responsible"
                      value={taskFormValues.responsible}
                      disabled={!isAdmin}
                      onChange={handleTaskChange}
                      className="rounded-tr-lg text-xs rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                      required
                    >   
                      <option value="">Seleccionar trabajador</option>
                      {trabajadoresList.map((worker) => (
                          <option key={worker.id} value={worker.id}>{worker.name} - {worker.puesto}</option>
                      ))}
                    </select>
                </div>
            </div>

            <div className="mb-12 flex flex-row justify-between px-8">

              <div className="flex flex-col gap-2">
                <label className="block text-gray-700 mb-2 text-xs" htmlFor="isProofNeeded">
                    Requiere pruebas
                </label>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isProofNeeded"
                    name="isProofNeeded"
                    checked={taskFormValues.isProofNeeded}
                    onChange={(e) => handleTaskChange({ target: { name: 'isProofNeeded', value: e.target.checked } })}
                    className="rounded border-gray-300 hover:cursor-pointer text-xs text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-2 text-gray-700 text-xs">{taskFormValues.isProofNeeded ? "Sí" : "No"}</span>
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="block text-gray-700 mb-2 text-xs" htmlFor="isMeeting">
                    Es reunión?
                </label>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isMeeting"
                    name="isMeeting"
                    checked={taskFormValues.isMeeting}
                    onChange={(e) => handleTaskChange({ target: { name: 'isMeeting', value: e.target.checked } })}
                    className="rounded border-gray-300 hover:cursor-pointer text-xs text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-2 text-gray-700 text-xs">{taskFormValues.isMeeting ? "Sí" : "No"}</span>
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="block text-gray-700 mb-2 text-xs" htmlFor="isVisit">
                    Es visita audiovisual?
                </label>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isVisit"
                    name="isVisit"
                    checked={taskFormValues.isVisit}
                    onChange={(e) => handleTaskChange({ target: { name: 'isVisit', value: e.target.checked } })}
                    className="rounded border-gray-300 hover:cursor-pointer text-xs text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-2 text-gray-700 text-xs">{taskFormValues.isVisit ? "Sí" : "No"}</span>
                </div>
              </div>
              
            </div>

            <div className="flex w-full gap-4">
              <button
                  type="button"
                  onClick={() => {
                    setNewTaskModal(false)
                    resetTaskFormValues()
                    setSelectedTaskText(false)
                    setFilteredTextTasks([])
                  }}
                  className="w-1/2 text-xs inline-flex items-center justify-center px-6 py-2 font-semibold text-white bg-gray-500 rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
              >
                <FaTimes className="mr-2"/>
                  Cancelar
              </button>
              <button 
                className={`w-1/2 text-xs inline-flex items-center justify-center px-6 py-2 font-semibold rounded-md shadow-md transition-colors duration-300 focus:outline-none focus:ring-2 ${
                  typeNewTask === "Existing" && !selectedTaskText
                    ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                    : 'bg-orange-500 hover:bg-orange-600 text-white focus:ring-orange-400'
                }`}
                type="submit"
                disabled={typeNewTask === "Existing" && !selectedTaskText}
              >
                <FaSave className="mr-2" />
                Guardar tarea
              </button>

            </div>

          </form>
          
      </Modal>

      <Modal // Modal para crear nuevos objetivos
          activeModal={newObjectiveModal}
          title={"Nuevo objetivo"}
          onClose={() => {
            setNewObjectiveModal(false)
            resetObjectiveFormValues()
          }}
          centered={true}
      >
          <form 
            onSubmit={handleObjectiveSubmit}
          >

            <div className="mb-4">
              <label className="block text-gray-700 mb-2 text-xs" htmlFor="phase">
                Fase
              </label>
              <div className="flex">
                <span className="inline-flex items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaCheck />
                </span>
                <input
                  type="text"
                  id="phase"
                  name="phase"
                  value={objectiveFormValues.phaseName}
                  className="rounded-tr-lg rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-xs border-gray-300 p-2.5"
                  disabled
                />
              </div>
            </div>

            <div className="mb-12">
              <label className="block text-gray-700 mb-2 text-xs" htmlFor="objective">
                  Objetivo
              </label>
              <div className="flex">
                <span className="inline-flex items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaBullseye />
                </span>
                <input
                  type="text"
                  id="objective"
                  name="objective"
                  placeholder="Objetivo 3: Descripción del objetivo"
                  value={objectiveFormValues.objective}
                  className="rounded-tr-lg rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-xs border-gray-300 p-2.5"
                  onChange={handleObjectiveChange}
                  required
                />
              </div>
            </div>

            <div className="flex w-full gap-4">
              <button
                  type="button"
                  onClick={() => {
                    setNewObjectiveModal(false)
                    resetObjectiveFormValues()
                  }}
                  className="w-1/2 inline-flex items-center justify-center px-6 py-2 text-xs font-bold text-white bg-gray-500 rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
              >
                <FaTimes className="mr-2"/>
                  Cancelar
              </button>
              <button 
                className="w-1/2 text-xs inline-flex items-center justify-center px-6 py-2 font-bold text-white bg-orange-500 rounded-md shadow-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
                type="submit"
              >
                <FaSave className="mr-2"/>
                Guardar objetivo
              </button>
            </div>

          </form>
      </Modal>

      <Modal // Modal para crear nuevas fases
        activeModal={newPhaseModal}
        title={"Nueva fase"}
        onClose={() => {
          setNewPhaseModal(false)
          resetPhaseFormValues()
        }}
        centered={true}
      >
        <form
          onSubmit={handlePhaseSubmit}
        >
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-xs" htmlFor="name">
                Nombre de la fase
            </label>
            <div className="flex">
                <span className="inline-flex items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaCheck />
                </span>
                <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Fase 4: Supervisión"
                    value={phaseFormValues.name}
                    onChange={handlePhaseChange}
                    className="rounded-tr-lg rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-xs border-gray-300 p-2.5"
                    />
            </div>
          </div>

          {/* <div className="mb-12">
            <label className="block text-gray-700 mb-2" htmlFor="deliverDate">
                Fecha de entrega
            </label>
            <div className="flex">
                <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaCheck />
                </span>
                <input
                  type="datetime-local"
                  id="deliverDate"
                  name="deliverDate"
                  value={formatDateTimeForInputWithoutRound(phaseFormValues.deliverDate)}
                  onChange={(e) =>
                    setPhaseFormValues((prevValues) => ({
                      ...prevValues,
                      deliverDate: e.target.value,
                    }))
                  }
                  className="rounded-tr-lg rounded-br-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                  />
            </div>
          </div> */}

          <div className="flex w-full gap-4">
            <button
                type="button"
                onClick={() => {
                  setNewPhaseModal(false)
                  resetPhaseFormValues()
                }}
                className="w-1/2 inline-flex items-center justify-center px-6 py-2 text-xs font-bold text-white bg-gray-500 rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
            >
              <FaTimes className="mr-2"/>
                Cancelar
            </button>
            <button 
                className="w-1/2 inline-flex items-center justify-center px-6 py-2 text-xs font-bold text-white bg-orange-500 rounded-md shadow-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
                type="submit"
            >
                <FaSave className="mr-2"/>
                Guardar fase
            </button>
          </div>

        </form>
      </Modal>

      <Modal // Modal para seleccionar la plantilla a utilizar
        activeModal={templateModalActive}
        title={"Plantilla a utilizar"}
        onClose={() => {
          setTemplateModalActive(false)
          setSelectedTemplate("")
        }}
      >
        <div className="">
          <label className="block text-gray-700 mb-4 text-xs" htmlFor="defaultResponsible">
              Seleccione la plantilla de procesos a utilizar
          </label>
          <div className="flex mb-12">
            <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
              <FaUser />
            </span>
            <select
                id="responsible"
                name="responsible"
                value={selectedTemplate}
                onChange={(e) => setSelectedTemplate(e.target.value)}
                className="rounded-none bg-gray-50 text-xs border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                required
            >   
                <option value="">Seleccionar plantilla</option>
                {templates.map((item, i) => (
                    <option key={i} value={item}>{item}</option>
                ))}
            </select>
          </div>
          <div className="flex w-full gap-4">
            <button
              type="button"
              onClick={() => {
                setTemplateModalActive(false)
                setSelectedTemplate("")
              }}
              className="w-1/2 inline-flex text-xs items-center justify-center px-6 py-2 font-bold text-white bg-gray-500 rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
            >
              <FaTimes className="mr-2"/>
                Cancelar
            </button>
            <button 
              className="w-1/2 inline-flex text-xs items-center justify-center px-6 py-2 font-bold text-white bg-orange-500 rounded-md shadow-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
              type="submit"
              onClick={() => {
                generateProcess()
                setTemplateModalActive(false)
                setSelectedTemplate("")
              }}
              disabled={selectedTemplate === ""}
            >
              <FaCheck className="mr-2"/>
              Generar proceso
            </button>
          </div>
        </div>
      </Modal>

      <Modal // Modal para mostrar las redes de los clientes
        activeModal={activeLinksClientsModal}
        title={"Links redes del cliente"}
        onClose={() => setActiveLinksClientsModal(false)}
        centered
      >
        <div className="flex flex-col gap-4">

          <div className="text-xs text-gray-700 font-bold bg-gray-50">
            Links creados
          </div>

          <div className="flex flex-col gap-2 items-center justify-center">
            {linksNetClients && linksNetClients.length > 0 ? (
              <>
                <div className="flex flex-row w-full gap-4 text-xs text-gray-700">
                  <span className="w-[50%] px-4">Nombre</span>
                  <span className="w-[50%] px-4">Link</span>
                </div>

                {linksNetClients.map((e) => (
                  <div key={e.id}className="flex flex-row w-full py-1 gap-4">

                    <div className="w-[50%] flex items-center justify-start px-4 border border-gray-300 rounded-lg py-1 bg-gray-50">
                      <span
                        className="text-xs"
                      >
                        {e.titulo}
                      </span>
                    </div>

                    <div className="w-[50%] flex items-center justify-start px-4 border border-gray-300 rounded-lg py-1 bg-gray-50">
                      <a 
                        rel={"noreferrer"} 
                        href={e?.url} 
                        target="_blank"
                        className="text-xs"               
                      > 
                        {e.url}
                      </a>
                    </div>

                  </div>
                ))}
              </>
            ) : (
              <div className="text-center w-full py-8 text-xs text-gray-700 bg-gray-50 border border-gray-300 rounded-lg">
                <span>No hay links creados</span>
              </div>
            )}
          </div>
        </div>
      </Modal>
    
      {/* NavBar */}
      <div className="px-4 py-2 bg-gray-100 mb-1">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [scrollbar-width:none]">
          <div className="flex items-center gap-4 py-4">
            <FaClipboardList className="text-zinc-700 text-2xl" />

            <Link to={'/home/seguimiento'}>
                <h2 className="truncate text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">Seguimiento de proyectos</h2>
            </Link>

            <FaChevronRight className="text-orange-500 text-2xl" />
            
            <Link to={`/home/seguimiento/${id}`}>
                <h2 className="truncate text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">{capitalizeWords(servicioData.cotizacion.cliente.nombreComercial)}</h2>
            </Link>

            <FaChevronRight className="text-orange-500 text-2xl" />

            <Link to={`/home/seguimiento/${id}/${activeServices}`}>
              <h2 className="truncate text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">{activeServices}</h2>
            </Link>

            <FaChevronRight className="text-orange-500 text-2xl" />

            <h2 className="truncate text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">{serviceId}</h2>
          </div>
        </div>
      </div>
      
      {/* Barra de metadatos */}
      <div className="flex gap-4 bg-gray-100 justify-between rounded-md py-1 px-4 mb-1 text-xs">

        <div className="flex flex-row gap-4 overflow-x-auto text-[10px] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="bg-gray-100 flex flex-row items-center gap-4">

            <span className="pr-4 border-r whitespace-nowrap pl-4 border-gray-300"> 
              % Proyecto: {" "}
              <span className={`${textColorClass} whitespace-nowrap`}>
                <MotionNumber
                  value={percentajeCompleted}
                  format={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }}
                  locales="en-US" // Intl.NumberFormat() locales
                />
                {" %"}
              </span>
            </span>

            <span className="pr-4 border-r whitespace-nowrap pl-4 border-gray-300">
              Total tareas: {" "}
              <span className={`${textColorClass} whitespace-nowrap`}>
                {
                  <>
                    <MotionNumber
                      value={tasksCompleted.length}
                      format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                      locales="en-US"
                    />
                    {" / "}
                    <MotionNumber
                      value={tasks.length}
                      format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                      locales="en-US"
                    />
                  </>
                }
              </span>
            </span>

            <span className="pr-4 border-r whitespace-nowrap pl-4 border-gray-300">
                Total objetivos: {" "}
                <span className={getTextColorForPercentage((completedObjectives/objectives.length) * 100)}>
                {
                  <>
                    <MotionNumber
                      value={completedObjectives}
                      format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                      locales="en-US"
                    />
                    {" / "}
                    <MotionNumber
                      value={objectives.length}
                      format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                      locales="en-US"
                    />
                  </>
                }
                </span>
            </span>

            <span className="pr-4 border-r whitespace-nowrap pl-4 border-gray-300">
                Total etapas: {" "}
                <span className={getTextColorForPercentage((completedPhases/phases.length * 100))}>
                  {
                  <>
                    <MotionNumber
                      value={completedPhases}
                      format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                      locales="en-US"
                    />
                    {" / "}
                    <MotionNumber
                      value={phases.length}
                      format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                      locales="en-US"
                    />
                  </>
                }
                </span>
            </span>

            <span className={`px-4 py-1 whitespace-nowrap ${GetStatusColor(servicioData.planServicio.name, PlanBackgroundColor)}`}>
              Plan: <span className="font-bold">{servicioData && servicioData?.planServicio?.name}</span>
            </span>

            {servicioData?.folderId && servicioData?.folderCreated && (
              <span className="pr-4 whitespace-nowrap pl-4 border-gray-300 flex items-center gap-1">
                <span className="font-bold text-blue-700 flex items-center gap-1">
                  <SiGoogledrive className="inline text-blue-500" />
                  <a
                    href={`https://drive.google.com/drive/folders/${servicioData.folderId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-blue-900"
                  >
                    Carpeta Drive
                  </a>
                </span>
              </span>
            )}
          </div>
          
          <div className="flex flex-row gap-8  text-[10px] items-center justify-center">

            <div className="w-full items-center flex flex-row text-[10px] gap-4">
              <h3 className="text-gray-700 truncate font-bold">
                Fecha Inicio:
              </h3>
              <input
                type="date"
                id="fechaInicio"
                name="fechaInicio"
                value={formValues.fechaInicio || ''}
                onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
                className={`px-2 py-0 font-bold hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-[10px]`}
                required
              />
            </div>

            <div className="w-full items-center flex flex-row text-[10px] gap-4">
              <h3 className="text-gray-700 truncate font-bold">
                Fecha Fin:
              </h3>
              <input
                type="date"
                id="fechaFin"
                name="fechaFin"
                value={formValues.fechaFin || ''}
                onChange={(e) => handleUpdateDate("fechaFin", e.target.value)}
                className={`px-2 py-0 font-bold hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-[10px]`}
                required
              />
            </div>

          </div>
        </div>
        
      </div>
        
      {/* Servicios asociados */ }
      <div className="flex gap-4 bg-gray-50 w-full rounded-md py-1 mb-1">

          <div className="flex flex-row gap-2 items-center justify-between w-full mx-4">

            <div className="flex items-center">
              {userStatus === "SuperAdmin" ? (
                <button 
                  onClick={() => setAssociateServicesModal(true)}
                  className="flex items-center text-xs justify-center py-0.5 px-4 gap-2 rounded-md bg-orange-500 font-bold text-white"
                >
                  <FaPlusCircle/>
                  <span>Asociar servicios</span>
                </button>
              ) : (
                <label className="text-xs">
                  Servicios asociados: {associatedServices.length}
                </label>
              )}
            </div>

            <div className="flex flex-row items-center justify-center gap-2">
              {servicioData.associatedServices?.map(associatedService => (
                <a 
                  href={`/home/seguimiento/${associatedService.brandId}/${associatedService.serviceName}/${associatedService.serviceId}`}
                  className="flex flex-row items-center justify-center bg-orange-500 rounded-md text-white font-semibold py-0.5 px-2"  
                >
                  <button className="text-xs">
                    {associatedService.serviceName}
                  </button>    
                </a>       
              ))}
            </div>

          </div>

      </div>

      {/* Barra de carga */}
      <div className="relative w-full bg-gray-200 rounded-full h-3 mb-1">
        <div
          className={`${backgroundColorClass} h-3 rounded-full transition-all duration-500`}
          style={{ width: `${percentajeCompleted.toFixed(2)}%` }}
        ></div>
        <span
          className="absolute inset-0 font-bold flex items-center justify-center text-xs text-black"
        >
        <MotionNumber
          value={percentajeCompleted}
          format={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          locales="en-US" // Intl.NumberFormat() locales
        />
        {" %"}
        </span>
      </div>
      
      {/* Barra de filtros */}
      <div className="flex flex-row gap-8 items-center justify-between bg-gray-100 mb-1 py-1 px-4">

        <div className="flex flex-row gap-4 overflow-x-auto text-[10px] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center justify-center gap-6">

            <span className="text-[10px] whitespace-nowrap">Tareas: {filteredTasks.length}</span>
            <Tooltip content={"Si el modo simple esta activo podrás aplicar filtros y ordenamientos. Es una vista sin objetivos ni fases."}>
              <div>
                <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
              </div>
            </Tooltip>
          
            <div className="flex flex-row gap-1">
              <span className="text-[10px] whitespace-nowrap font-bold">Modo simple</span>
              <input
                id="activeFilter"
                type="checkbox"
                checked={simpleMode}
                onChange={() => setSimpleMode(!simpleMode)}
                className="rounded-md border-gray-400 hover:cursor-pointer"
              />
            </div>

            <div className="flex flex-row gap-1">
              <span className="text-[10px] whitespace-nowrap font-bold">Visita Av.</span>
              <input
                id="filterAv"
                type="checkbox"
                checked={filterAv} 
                onChange={() => setFilterAv(!filterAv)}
                className="rounded-md border-gray-400 hover:cursor-pointer"
              />
            </div>

            <div className="flex flex-row gap-1">
              <span className="text-[10px] whitespace-nowrap font-bold">Meets</span>
              <input
                id="filterMeets"
                type="checkbox"
                checked={filterMeets}
                onChange={() => setFilterMeets(!filterMeets)}
                className="rounded-md border-gray-400 hover:cursor-pointer"
              />
            </div>

          </div>
    
          <div className="flex flex-row justify-center items-center gap-8">

            <div className="flex flex-row gap-2">
              <span className="text-[10px] whitespace-nowrap">Ocultar Finalizadas</span>
              <input
                id="activeFilter"
                type="checkbox"
                checked={hideFinished}
                disabled={!simpleMode}
                onChange={() => setHideFinished(!hideFinished)}
                className={`rounded-md border-gray-400 ${simpleMode && `hover:cursor-pointer`}`}
              />
            </div>

            <div className="flex flex-row gap-2">
              <span className="text-[10px] whitespace-nowrap">Ocultar Pendientes</span>
              <input
                id="activeFilter"
                type="checkbox"
                checked={hidePending}
                disabled={!simpleMode}
                onChange={() => setHidePending(!hidePending)}
                className={`rounded-md border-gray-400 ${simpleMode && `hover:cursor-pointer`}`}
              />
            </div>

            <div className="flex flex-row items-center justify-center gap-4">
              <label htmlFor="filteringCriteria" className="text-[10px] whitespace-nowrap">Filtrar por</label>
              <select
                value={taskFilteringCriteria}
                onChange={(e) => {
                  setTaskFilteringCriteria(e.target.value)
                  setTaskFilter("Todos")
                }}
                disabled={!simpleMode}
                className={`bg-gray-50 text-[10px] border ${simpleMode && `hover:cursor-pointer`} border-gray-300 text-gray-900 w-[200px] rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-0 px-2`}
              >
                <option value="Todos">Todos</option>
                <option value="Etiqueta">Etiqueta</option>
                <option value="Responsable">Responsable</option>
                <option value="Objetivo">Objetivo</option>
                <option value="Fase">Fase</option>
                <option value="Estado">Estado</option>
                {/* <option value="Reunion">Reunión</option>
                <option value="Visita AV">Visita AV</option> */}
                <option value="Visible cliente">Visible cliente</option>
                <option value="Puntaje">Puntaje</option>
                <option value="Puntaje asignado">Puntaje asignado</option>
              </select>
            </div>

            <div className="flex flex-row items-center justify-center gap-4">
              <label htmlFor="filteringCriteria" className="text-[10px] whitespace-nowrap">Criterio de filtro</label>
              <select
                value={taskFilter}
                onChange={(e) => setTaskFilter(e.target.value)}
                disabled={taskFilteringCriteria === "Todos" ||  !simpleMode}
                className={`bg-gray-50 text-[10px] border ${simpleMode && `hover:cursor-pointer`} border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-0 px-2 w-[170px]`}
              >
                <option value="Todos">Todos</option>
                {taskFilteringCriteria !== "Todos" &&
                  filterOptions[taskFilteringCriteria]?.map((option) => (
                    <option key={option.id || option} value={option.id || option}>
                      {typeof option === "object" ? option.name : option}
                    </option>
                  ))}
              </select>
            </div>

            <div className="flex flex-row items-center justify-center gap-4">
              <label htmlFor="filteringCriteria" className="text-[10px] whitespace-nowrap">Ordenar por</label>
              <select
                value={taskOrderCriteria}
                onChange={(e) => setTaskOrderCriteria(e.target.value)}
                disabled={!simpleMode}
                className={`bg-gray-50 text-[10px] border ${simpleMode && `hover:cursor-pointer`} border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-0 px-2 w-[100px]`}
              >
                <option value="Tarea">Tarea</option>
                <option value="Etiqueta">Etiqueta</option>
                <option value="Responsable">Responsable</option>
                <option value="Objetivo">Objetivo</option>
                <option value="Fase">Fase</option>
                <option value="Puntaje">Puntaje</option>
                <option value="Puntaje asignado">Puntaje asignado</option>
                <option value="Estado">Estado</option>
              </select>
            </div>

          </div>
        </div>
        
      </div>
      
      {/* Tabs */}
      <div className="flex flex-row items-center justify-between border-b border-gray-300">
        <ul className="flex flex-row justify-start text-sm font-medium text-center border-b border-gray-300">
          {tabs
            .filter((tab) => tab.show === true)
            .map((e) => (
              <li key={e.id}>
                <button
                  onClick={() => setActiveTab(e)}
                  type="button"
                  className={`${
                    activeTab?.id === e?.id
                      ? "bg-orange-500 text-white border-orange-500"
                      : "bg-orange-100 text-orange-700 border-transparent"
                  } px-4 py-2 text-xs rounded-t-md border-t border-l border-r cursor-pointer flex flex-row items-center gap-2 transition-all duration-300 ease-in-out hover:bg-orange-200 hover:text-orange-800`}
                >
                  {`${e.name}`}
                  <e.icon className="text-xl" />
                </button>
              </li>
            ))}
        </ul>

        {activeTab.id === 2 && groupedData.length > 0 && userStatus === "SuperAdmin" && (
          <button 
            className="flex items-center justify-center gap-2 mr-4 px-4 py-1 bg-red-600 rounded-lg text-white shadow font-bold text-xs"
            onClick={deleteProcess}
          >
            <FaTimes />
            Eliminar proceso
          </button>
        )}
      </div>

      {activeTab.id === tabs[0].id && (

        <div className="flex-grow w-full mx-auto flex flex-col gap-4 md:flex-row pt-4">

          <div className="p-3 shadow border rounded md:w-1/3">
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-300 text-sm text-slate-600 text-xs">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-2 border border-gray-300 text-left">Servicio</th>
                    <th className="px-4 py-2 border border-gray-300 text-left">Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {parsedDescription.map((service, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                      <td className="px-4 py-2 border border-gray-300">{service.key}</td>
                      <td className="px-4 py-2 border border-gray-300">{service.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex flex-col md:w-1/3 gap-4">

            {servicioData.checklistProgress ? (
              <ChecklistServicio 
                checklist={servicioData.checklistProgress}
                checklistCompleted={servicioData.checklistCompleted}
                setServicioData={setServicioData}
                serviceId={servicioData.id}
                checklistCompletedDate={servicioData.checklistCompletedDate}
                checklistMedia={servicioData.checklistMedia}
                checklistNotes={servicioData.checklistNotes}
              />
            ) : (
              <div className="p-3 shadow border rounded text-xs">
                <h3 className="text-md font-bold text-slate-600 mb-2">Checklist</h3>
                <p className="text-slate-600 whitespace-pre-line px-2">
                  No hay checklist para este servicio.
                </p>
              </div>
            )}

            {ClientsDataCategories.some(cat => cat.value === servicioData?.servicio?.categoria) && (
              <div className="p-3 shadow border rounded text-xs">
                <div className="flex flex-col gap-2">
                  <h3 className="text-md font-bold text-slate-600">Datos de cliente</h3>
                  <p className="text-slate-600 whitespace-pre-line px-2">
                    Gestiona teléfonos, correos y WhatsApp del cliente asociados a este servicio.
                  </p>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedClientData(servicioData);
                      setOpenModalClientData(true);
                    }}
                    className="self-start mt-1 px-3 py-1.5 text-[11px] font-semibold rounded bg-orange-500 text-white hover:bg-orange-600 transition-colors"
                  >
                    Abrir datos del cliente
                  </button>
                </div>
              </div>
            )}

            {servicioData.servicio.categoria === "Web" && (
              <>
                <div className="p-3 shadow border rounded text-xs">
                  <div className="flex flex-col gap-0 items-center justify-center">
                    <div className="flex flex-row w-full items-center justify-between">
                      <h3 className="text-md font-bold text-slate-600">Características Aula virtual</h3>
                      <div className="flex flex-row gap-2 items-center justify-center">
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasAulaVirtualBasico, "AulaVirtual")}
                        >
                          AVB
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasAulaVirtualIntermedio, "AulaVirtual")}
                        >
                          AVI
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasAulaVirtual, "AulaVirtual")}
                        >
                          AVA
                        </button>
                      </div>
                    </div>

                    <div className="flex flex-row w-full items-center justify-between">
                      <span>Opciones seleccionadas: {aulaVirtualChars.length}</span>
                      <IconButton
                        onClick={() => setShowAv(!showAv)}
                        color="primary"
                        size="small"
                        aria-label="expand"
                        sx={{ transition: "0.3s", transform: showAv ? "rotate(180deg)" : "rotate(0deg)" }}
                      >
                        <ExpandMoreIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </div>
                  </div>
                  {showAv && (
                    <div className="grid grid-cols-1 gap-2 mt-2">
                      {CaracteristicasAulaVirtual.map((c, i) => (
                        <div key={i} className="bg-gray-100 justify-between px-2 py-1 rounded-full flex flex-row gap-2 items-center">
                          <div className="flex flex-col w-[90%]">
                            <span className="text-xs truncate" title={c}>{c}</span>
                          </div>
                          <input
                            type="checkbox"
                            className="rounded-md border-gray-400 hover:cursor-pointer"
                            checked={selectedCharacteristics.includes(c)}
                            onChange={(e) => handlerChangeCharsFilter(c, e.target.checked, "AulaVirtual")}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="p-3 shadow border rounded text-xs">
                  <div className="flex flex-col gap-0 items-center justify-center">
                    <div className="flex flex-row w-full items-center justify-between">
                      <h3 className="text-md font-bold text-slate-600 mb-2">Características Tienda virtual</h3>
                      <div className="flex flex-row gap-2 items-center justify-center">
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasTiendaVirtualBasico, "TiendaVirtual")}
                        >
                          TVB
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasTiendaVirtualIntermedio, "TiendaVirtual")}
                        >
                          TVI
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasTiendaVirtual, "TiendaVirtual")}
                        >
                          TVA
                        </button>
                      </div>
                    </div>
                    
                    <div className="flex flex-row w-full items-center justify-between">
                      <span>Opciones seleccionadas: {tiendaVirtualChars.length}</span>
                      <IconButton
                        onClick={() => setShowTv(!showTv)}
                        color="primary"
                        size="small"
                        aria-label="expand"
                        sx={{ transition: "0.3s", transform: showTv ? "rotate(180deg)" : "rotate(0deg)" }}
                      >
                        <ExpandMoreIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </div>
                  </div>
                  {showTv && (
                    <div className="grid grid-cols-1 gap-2">
                      {CaracteristicasTiendaVirtual.map((c, i) => (
                        <div key={i} className="bg-gray-100 justify-between px-2 py-1 rounded-full flex flex-row gap-2 items-center">
                          <div className="flex flex-col w-[90%]">
                            <span className="text-xs truncate" title={c}>{c}</span>
                          </div>
                          <input
                            type="checkbox"
                            className="rounded-md border-gray-400 hover:cursor-pointer"
                            checked={selectedCharacteristics.includes(c)}
                            onChange={(e) => handlerChangeCharsFilter(c, e.target.checked, "TiendaVirtual")}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="p-3 shadow border rounded text-xs">
                  <div className="flex flex-col gap-0 items-center justify-center">
                    <div className="flex flex-row w-full items-center justify-between">
                      <h3 className="text-md font-bold text-slate-600 mb-2">Características Web Informativa</h3>
                      <div className="flex flex-row gap-2 items-center justify-center">
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasWebInformativaBasica, "WebInformativa")}
                        >
                          AVB
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasWebInformativaIntermedia, "WebInformativa")}
                        >
                          AVI
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasWebInformativa, "WebInformativa")}
                        >
                          AVA
                        </button>
                      </div>
                    </div>

                    <div className="flex flex-row w-full items-center justify-between">
                      <span>Opciones seleccionadas: {webInformativaChars.length}</span>
                      <IconButton
                        onClick={() => setShowWi(!showWi)}
                        color="primary"
                        size="small"
                        aria-label="expand"
                        sx={{ transition: "0.3s", transform: showWi ? "rotate(180deg)" : "rotate(0deg)" }}
                      >
                        <ExpandMoreIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </div>
                  </div>
                  {showWi && (
                    <div className="grid grid-cols-1 gap-2">
                      {CaracteristicasWebInformativa.map((c, i) => (
                        <div key={i} className="bg-gray-100 justify-between px-4 py-1 rounded-full flex flex-row gap-2 items-center">
                          <div className="flex flex-col w-[90%]">
                            <span className="text-xs truncate" title={c}>{c}</span>
                          </div>
                          <input
                            type="checkbox"
                            className="rounded-md border-gray-400 hover:cursor-pointer"
                            checked={selectedCharacteristics.includes(c)}
                            onChange={(e) => handlerChangeCharsFilter(c, e.target.checked, "WebInformativa")}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="p-3 shadow border rounded text-xs">
                  <div className="flex flex-col gap-0 items-center justify-center">
                    <div className="flex flex-row w-full items-center justify-between">
                      <h3 className="text-md font-bold text-slate-600 mb-2">Características Adicionales</h3>
                      <div className="flex flex-row gap-2 items-center justify-center">
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasAdicionalesBasico, "Adicional")}
                        >
                          CAB
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasAdicionalesIntermedio, "Adicional")}
                        >
                          CAI
                        </button>
                        <button
                          className="bg-orange-500 border rounded text-white font-semibold text-[10px] px-2 py-0.2"
                          onClick={() => handleSelectCategory(CaracteristicasAdicionales, "Adicional")}
                        >
                          CAA
                        </button>
                      </div>
                    </div>

                    <div className="flex flex-row w-full items-center justify-between">
                      <span>Opciones seleccionadas: {adicionalChars.length}</span>
                      <IconButton
                        onClick={() => setShowAd(!showAd)}
                        color="primary"
                        size="small"
                        aria-label="expand"
                        sx={{ transition: "0.3s", transform: showAd ? "rotate(180deg)" : "rotate(0deg)" }}
                      >
                        <ExpandMoreIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </div>
                  </div>
                  {showAd && (
                    <div className="grid grid-cols-1 gap-2">
                      {CaracteristicasAdicionales.map((c, i) => (
                        <div key={i} className="bg-gray-100 justify-between px-4 py-1 rounded-full flex flex-row gap-2 items-center">
                          <div className="flex flex-col w-[90%]">
                            <span className="text-xs truncate" title={c}>{c}</span>
                          </div>
                          <input
                            type="checkbox"
                            className="rounded-md border-gray-400 hover:cursor-pointer"
                            checked={selectedCharacteristics.includes(c)}
                            onChange={(e) => handlerChangeCharsFilter(c, e.target.checked, "Adicional")}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}

            {/* {servicioData.servicio.categoria !== "Web" && (
              <>
                <div className="p-3 shadow border rounded text-xs">
                  <h3 className="text-md font-bold text-slate-600 mb-2">Cliente</h3>

                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">

                    <p className="text-slate-600 whitespace-pre-line px-2">
                      <span className="font-bold">Email: </span>{servicioData.cotizacion.cliente.email || servicioData.cotizacion.cliente.emailGerencia} <br />
                      <span className="font-bold">Número: </span>{servicioData.cotizacion.cliente.telefono || servicioData.cotizacion.cliente.telefonoGerente} <br />
                      <span className="font-bold">RUC: </span>{servicioData.cotizacion.cliente.ruc}
                    </p>  

                  </div>
                </div>       

                <div className="p-3 shadow border rounded text-xs">

                  <h3 className="text-md font-bold text-slate-600 mb-2">Vendedor</h3>

                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                    <div className="px-2">
                      <p className="text-base font-semibold leading-none text-gray-900 text-xs">
                        <span href="#" className="">
                          {servicioData?.cotizacion?.cotizador?.name}
                        </span>
                      </p>
                      <p className="text-gray-600 text-xs capitalize font-normal">
                        {servicioData?.cotizacion?.cotizador?.puesto}
                      </p>
                    </div>
                    <div>
                      <img
                        className="w-10 h-10 object-cover rounded-full mr-2"
                        src={
                          servicioData?.cotizacion?.cotizador.foto?.url
                            ? servicioData?.cotizacion?.cotizador.foto?.url
                            : "/assets/images/avatars/avatar_8.jpg"
                        }
                        alt="Flowbite logo"
                      />
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-b p-3">
                    {servicioData?.comentarioVendedor ? (
                      <p className="whitespace-pre-line text-xs font-light text-base">
                        {servicioData?.comentarioVendedor}
                      </p>
                    ) : (
                      <p className="flex font-light text-xs text-gray-600 justify-center italic">
                        ** Ningún comentario **
                      </p>
                    )}
                  </div>

                </div>

                <div className="p-3 shadow border rounded text-xs">

                  <h3 className="text-md font-bold text-slate-600 mb-2">Responsable</h3>

                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">

                    <div className="w-[80%]">
                      <select
                        value={serviceResponsible ? serviceResponsible.id : ""}
                        disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) => {
                          const selectedTrabajador = trabajadoresList.find(t => t.id === e.target.value);
                          setServiceResponsible(selectedTrabajador || null);
                        }}
                        className="text-base text-xs font-semibold leading-none text-gray-900 w-full border-none rounded-full hover:cursor-pointer bg-gray-100 px-2 py-0" 
                      >
                        <option key={""} value={""} className="text-black">Seleccionar trabajador</option>
                        {trabajadoresList.map((trabajador) => (
                          <option key={trabajador.id} value={trabajador.id}>
                            {trabajador.name} - {trabajador.puesto}
                          </option>
                        ))}
                      </select>
                      <p className="text-gray-600 text-xs capitalize font-normal px-2">
                        {serviceResponsible?.puesto || "No se ha asignado un responsable"}
                      </p>
                    </div>


                    <div className="">
                      <img
                        className="w-10 h-10 object-cover rounded-full mr-2"
                        src={
                          serviceResponsible?.foto?.url
                            ? serviceResponsible?.foto?.url
                            : "/assets/images/avatars/avatar_8.jpg"
                        }
                        alt="Trabajador"
                      />
                    </div>
                  </div>

                </div>
              </>
            )} */}

          </div>

          <div className="md:w-1/3 flex flex-col gap-4">

            {/* {servicioData.servicio.categoria === "Web" && ( */}
              <div className="flex flex-col gap-4">
                <div className="p-3 shadow border rounded text-xs">
                  <h3 className="text-md font-bold text-slate-600 mb-2">Cliente</h3>

                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">

                    <p className="text-slate-600 whitespace-pre-line px-2">
                      <span className="font-bold">Email: </span>{servicioData.cotizacion.cliente.email || servicioData.cotizacion.cliente.emailGerencia} <br />
                      <span className="font-bold">Número: </span>{servicioData.cotizacion.cliente.telefono || servicioData.cotizacion.cliente.telefonoGerente} <br />
                      <span className="font-bold">RUC: </span>{servicioData.cotizacion.cliente.ruc}
                    </p>  

                  </div>
                </div>       

                <div className="p-3 shadow border rounded text-xs">

                  <h3 className="text-md font-bold text-slate-600 mb-2">Vendedor</h3>

                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                    <div className="px-2">
                      <p className="text-base font-semibold leading-none text-gray-900 text-xs">
                        <span href="#" className="">
                          {servicioData?.cotizacion?.cotizador?.name}
                        </span>
                      </p>
                      <p className="text-gray-600 text-xs capitalize font-normal">
                        {servicioData?.cotizacion?.cotizador?.puesto}
                      </p>
                    </div>
                    <div>
                      <img
                        className="w-10 h-10 object-cover rounded-full mr-2"
                        src={
                          servicioData?.cotizacion?.cotizador.foto?.url
                            ? servicioData?.cotizacion?.cotizador.foto?.url
                            : "/assets/images/avatars/avatar_8.jpg"
                        }
                        alt="Flowbite logo"
                      />
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-b p-3">
                    {servicioData?.comentarioVendedor ? (
                      <p className="whitespace-pre-line text-xs font-light text-base">
                        {servicioData?.comentarioVendedor}
                      </p>
                    ) : (
                      <p className="flex font-light text-xs text-gray-600 justify-center italic">
                        ** Ningún comentario **
                      </p>
                    )}
                  </div>

                  {servicioData.audios && servicioData.audios?.length > 0 && (
                    <>
                      <h3 className="text-md font-bold text-slate-600 mt-4 mb-2">Audios del área comercial</h3>
                      <div className="flex flex-col gap-2 w-full">
                        {servicioData.audios?.map((audio) => (
                          <div className="flex items-center gap-2">
                            <audio 
                              src={audio.url} 
                              controls 
                              className="w-full h-8 [&::-webkit-media-controls-time-remaining-display]:text-xs [&::-webkit-media-controls-current-time-display]:text-xs"
                              controlsList="nodownload"
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                </div>

                <div className="p-3 shadow border rounded text-xs">

                  <h3 className="text-md font-bold text-slate-600 mb-2">Responsable</h3>

                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">

                    <div className="w-[80%]">
                      <select
                        value={serviceResponsible ? serviceResponsible.id : ""}
                        disabled={!isAdmin}
                        onChange={(e) => {
                          const selectedTrabajador = trabajadoresList.find(t => t.id === e.target.value);
                          setServiceResponsible(selectedTrabajador || null);
                        }}
                        className="text-base text-xs font-semibold leading-none text-gray-900 w-full border-none rounded-full hover:cursor-pointer bg-gray-100 px-2 py-0" 
                      >
                        <option key={""} value={""} className="text-black">Seleccionar trabajador</option>
                        {trabajadoresList.map((trabajador) => (
                          <option key={trabajador.id} value={trabajador.id}>
                            {trabajador.name} - {trabajador.puesto}
                          </option>
                        ))}
                      </select>
                      <p className="text-gray-600 text-xs capitalize font-normal px-2">
                        {serviceResponsible?.puesto || "No se ha asignado un responsable"}
                      </p>
                    </div>


                    <div className="">
                      <img
                        className="w-10 h-10 object-cover rounded-full mr-2"
                        src={
                          serviceResponsible?.foto?.url
                            ? serviceResponsible?.foto?.url
                            : "/assets/images/avatars/avatar_8.jpg"
                        }
                        alt="Trabajador"
                      />
                    </div>
                  </div>

                </div>
              </div>
            {/* )} */}

            <div className="flex flex-col p-3 rounded border shadow gap-4">
              <h3 className="text-lg font-bold text-slate-600 mb-2 text-xs">Integrantes por etiqueta</h3>

              <div className="flex flex-col gap-4">
                {labels.map((task, index) => (
                  <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4" key={index}>
                    <div className="w-[80%] px-2">
                      <select
                        value={task.responsible ? task.responsible.id : ""}
                        onChange={(e) => handleResponsibleChange(e, task.label)}
                        disabled={userStatus !== "SuperAdmin"}
                        className="text-base text-xs font-semibold leading-none text-gray-900 w-full border-none rounded-full hover:cursor-pointer bg-gray-100 px-2 py-0"
                      >
                        <option key={"0"} value={"0"} className="text-black">Seleccionar trabajador</option>
                        {trabajadoresList.map((trabajador) => (
                          <option key={trabajador.id} value={trabajador.id}>
                            {trabajador.name} - {trabajador.puesto}
                          </option>
                        ))}
                      </select>
                      <p className="text-gray-600 text-xs capitalize font-normal px-2">
                        {task?.label} - {task?.count} tareas
                      </p>
                    </div>

                    <div>
                      <img
                        className="w-10 h-10 object-cover rounded-full mr-2"
                        src={
                          task?.responsible?.foto?.url
                            ? task?.responsible?.foto?.url
                            : "/assets/images/avatars/avatar_8.jpg"
                        }
                        alt="Flowbite logo"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>
      )}

      {/* Modal de datos del cliente (solo si se ha seleccionado un servicio) */}
      <ClientDataModal
        openModalClientData={openModalClientData}
        setOpenModalClientData={setOpenModalClientData}
        selectedClientData={selectedClientData}
        setSelectedClientData={setSelectedClientData}
        setServicioData={setServicioData}
      />

      {activeTab.id === tabs[1].id && (
        loadingText !== "" ? (
          <div className="flex-grow flex items-center justify-center gap-4 m-4 border rounded shadow">
            <FaSpinner className="animate-spin text-gray-500 h-4 w-4" />
            <span className="text-xs text-gray-500">{loadingText}</span>
          </div>
        ) : (
          simpleMode ? (
            filteredTasks.length > 0 ? (
              <div className="flex-grow overflow-auto">
                <table className="w-full bg-gray-50">
                  <thead>
                    <tr className="bg-gray-200 sticky top-0 z-10 text-xs">
                      <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[5%]">Etiqueta</th>
                      <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[30%]">Nombre de la Tarea</th>
                      <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[20%]">Responsable</th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Iniciar tarea"> 
                          <div>
                            <FaPlay className="mx-auto" />
                          </div>
                        </Tooltip>
                      </th>
                      <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[10%]">Estado</th>
                      <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[10%]">Entregar</th>
                      <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[10%]">Fecha de entrega</th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Pruebas de la tarea."> 
                          <div>
                            <FaImage className="mx-auto" />
                          </div>
                        </Tooltip>
                      </th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Enlaces de la tarea."> 
                          <div>
                            <FaLink className="mx-auto" />
                          </div>
                        </Tooltip>  
                      </th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Audios de administración respecto a la tarea."> 
                          <div>
                            <FaVolumeUp className="mx-auto" />
                          </div>
                        </Tooltip>   
                      </th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Tarea bloqueada."> 
                          <div>
                            <FaLock className="mx-auto" />
                          </div>
                        </Tooltip> 
                      </th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Puntaje de la tarea."> 
                          <div>
                            <FaTrophy className="mx-auto" />
                          </div>
                        </Tooltip> 
                      </th>
                      <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                        <Tooltip content="Persona a la que se asigna el puntaje de la tarea."> 
                          <div>
                            <FaUser className="mx-auto" />
                          </div>
                        </Tooltip> 
                      </th>
                        {userStatus === "SuperAdmin" && (
                          <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]"><FaTrash className="mx-auto"/></th>
                        )}
                      </tr>
                  </thead>
                  <tbody>
                    {filteredTasks
                      .map((task) => (
                        <ItemRowTareaProyecto
                          key={task.id}
                          task={task}
                          userStatus={userStatus}
                          successChildUpdate={successChildUpdate}
                          trabajadores={trabajadoresList}
                          addRegisterTaskEvents={addRegisterTaskEvents}
                          clientName={servicioData.cotizacion.cliente.nombreComercial}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="flex-grow flex items-center justify-center gap-4 m-4 border rounded shadow">
                <FaInfoCircle className="text-gray-500 h-4 w-4" />
                <span className="text-xs text-gray-500">No hay tareas que coincidan con los filtros.</span>
              </div>
            )
          ) : (
            groupedData.length > 0 ? (
              <div className="flex-grow overflow-auto">
                {groupedData.map((fase) => (
                  <div key={fase.id}>
                    {/* Botón de Fase */}
                    <div
                      className={`w-full h-8 border-none sticky text-white text-xs top-0 rounded shadow-md px-16 p-2 flex z-10 items-center justify-between font-bold transition-all duration-100 ease-in-out font-semibold bg-gray-500`}
                    >
                      <span>{fase.name} </span>
                    </div>
                      {
                      <table className="w-full table-auto bg-gray-50">
                        <thead>
                          <tr className="bg-gray-200 h-8 sticky top-8 z-10 text-xs">
                            <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[5%]">Etiqueta</th>
                            <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[30%]">Nombre de la Tarea</th>
                            <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[20%]">Responsable</th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                              <Tooltip content="Iniciar o pausar la tarea."> 
                                <div>
                                  <FaPlay className="mx-auto" />
                                </div>
                              </Tooltip>
                            </th>
                            <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[10%]">Estado</th>
                            <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[10%]">Entregar</th>
                            <th className="p-2 border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[10%]">Fecha de entrega</th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                              <Tooltip content="Pruebas de la tarea."> 
                                <div>
                                  <FaImage className="mx-auto" />
                                </div>
                              </Tooltip>
                            </th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                              <Tooltip content="Enlaces de la tarea."> 
                                <div>
                                  <FaLink className="mx-auto" />
                                </div>
                              </Tooltip>
                            </th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                              <Tooltip content="Audios de administración respecto a la tarea."> 
                                <div>
                                  <FaVolumeUp className="mx-auto" />
                                </div>
                              </Tooltip> 
                            </th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">                          
                              <Tooltip content="Tarea bloqueada."> 
                                <div>
                                  <FaLock className="mx-auto" />
                                </div>
                              </Tooltip> 
                            </th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                              <Tooltip content="Puntaje de la tarea."> 
                                <div>
                                  <FaTrophy className="mx-auto" />
                                </div>
                              </Tooltip> 
                            </th>
                            <th className="border-none font-normal text-xs text-zinc-700 whitespace-pre-line w-[1px]">
                              <Tooltip content="Persona a la que se asigna el puntaje de la tarea."> 
                                <div>
                                  <FaUser className="mx-auto" />
                                </div>
                              </Tooltip>
                            </th>
                            {userStatus === "SuperAdmin" && (
                              <th className="w-[1px] border-none font-normal text-xs text-zinc-700 whitespace-pre-line"><FaTrash className="mx-auto"/></th>
                            )}
                          </tr>
                        </thead>
  
                        <tbody>
                          {fase.objetivos.map((objetivo) => {
                            // Calcular el porcentaje de tareas completadas
                            const totalTareas = objetivo.tareas.length;
                            const tareasCompletadas = objetivo.tareas.filter(tarea => tarea.delivered === true).length;
                            const porcentajeCompletado = totalTareas > 0 ? (tareasCompletadas / totalTareas) * 100 : 0;
  
                            return (
                              <>
                                {/* Fila de objetivo con porcentaje */}
                                <tr key={objetivo.id} className="text-xs">
                                  <td className={`border-none font-semibold sticky top-16 z-10 p-2 transition-all duration-100 ease-in-out bg-gray-300 hover:bg-gray-300`} colSpan="14">
                                    <button
                                      className={`flex w-full justify-between transition-all duration-100 ease-in-out text-xs text-zinc-700 whitespace-pre-line`}
                                      //onClick={() => toggleObjective(objetivo)}
                                    >
                                      <span>
                                        {objetivo.name}
                                      </span>
                                      <span className={`${getTextColorForPercentage(porcentajeCompletado)} ml-8`}>
                                        {porcentajeCompletado.toFixed(0)} % completado
                                      </span>
                                    </button>
                                  </td>
                                </tr>
  
                                {/* Filas de tareas */}
                                {
                                  <>
                                    {objetivo.tareas.map((task) => (
                                      <ItemRowTareaProyecto 
                                        key={task.id}
                                        task={task}
                                        userStatus={userStatus}
                                        successChildUpdate={successChildUpdate}
                                        trabajadores={trabajadoresList}
                                        addRegisterTaskEvents={addRegisterTaskEvents}
                                        firstMeeting={task.id === firstMeetingWithClient}
                                        clientName={servicioData.cotizacion.cliente.nombreComercial}
                                      />
                                    ))}
                                    {/* { userStatus === "SuperAdmin" && ( */}
                                      <tr key={"1"} className="">
                                        <td
                                          className="border font-semibold p-2 transition-all duration-100 ease-in-out bg-blue-100 hover:bg-blue-200"
                                          colSpan="14"
                                        >
                                          <button
                                            className="flex justify-center w-full transition-all duration-100 ease-in-out text-xs text-zinc-700 whitespace-pre-line items-center"
                                            onClick={() => {
                                              setNewTaskModal(true)
                                              setTaskFormValues({
                                                name: "",
                                                objective: objetivo.id,
                                                objectiveName: objetivo.name,
                                                responsible: user.id,
                                                serviceId: serviceId,
                                                isProofNeeded: false
                                              })
                                            }}
                                            >
                                            <span className="text-blue-500 flex flex-row items-center justify-center gap-2">
                                              Nueva tarea <FaPlus className="text-blue-500"/>
                                            </span>
                                          </button>
                                        </td>
                                      </tr>
                                    {/* )} */}
                                  </>
                                }
                              </>
                            );
                          })}
                        </tbody>
                        {userStatus === "SuperAdmin" && (
                          <tr key={"1"} className="">
                            <td
                              className="border font-semibold p-2 transition-all duration-100 ease-in-out bg-blue-100 hover:bg-blue-200"
                              colSpan="14"
                            >
                              <button
                                className="flex justify-center w-full transition-all duration-100 ease-in-out text-xs text-zinc-700 whitespace-pre-line items-center"
                                onClick={() => {
                                  setNewObjectiveModal(true)
                                  setObjectiveFormValues({
                                    objective: "",
                                    phase: fase.id,
                                    phaseName: fase.name
                                  })
                                }}
                              >
                                <span className="text-blue-500 flex flex-row items-center justify-center gap-2">
                                  Nuevo objetivo <FaPlus className="text-blue-500"/>
                                </span>
                              </button>
                            </td>
                          </tr>
                        )}
                      </table>
                    }
                  </div>
                ))}
                { userStatus === "SuperAdmin" && (
                  <button
                    className={`w-full border rounded-md shadow-md p-2 justify-center transition-all duration-100 ease-in-out text-xs font-semibold bg-blue-100 hover:bg-blue-200`}
                    onClick={() => setNewPhaseModal(true)}
                  >
                    <span className="text-blue-500 flex flex-row items-center justify-center gap-2">
                      Nueva Fase <FaPlus className="text-blue-500"/>
                    </span>
                  </button>
                )}
              </div>
            ) : (
              <div className="flex-grow flex items-center justify-center gap-4 m-4 border rounded shadow">
                <div className="flex flex-col items-center justify-center gap-4">
                  <div className="flex flex-row justify-center items-center gap-4">
                    <FaInfoCircle className="text-gray-500 h-4 w-4" />
                    <span className="text-xs text-gray-500">No se ha creado un proceso para este servicio.</span>
                  </div>
                  {isAdmin && (
                    <button 
                      className="inline-flex items-center px-6 py-2 text-xs font-bold text-white bg-orange-500 rounded-md shadow-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
                      onClick={() => setTemplateModalActive(true)}
                    >
                      <FaPlus className="mr-2" />
                      Generar proceso 
                    </button>
                  )}
                </div>
              </div>
            )
          )

        )
      )}

      {activeTab.id === tabs[2].id && (
        <div className="mb-8 mt-4">
          <div className="w-full mx-auto bg-white rounded-md flex flex-col gap-2 md:grid md:grid-cols-3 md:gap-6">

            {/* Datos generales */}
            <div className="p-3 shadow border rounded">

              <h3 className="text-sm font-bold text-slate-600 mb-2">Datos Generales</h3>

              <div className="my-3 flex flex-col justify-start h-full gap-2">

                <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                  <p className="text-xs text-slate-600 whitespace-pre-line">
                    <span className="font-bold">ID Cotización: </span>{servicioData.cotizacion.id}<br />
                  </p>  
                </div>

                {servicioData.servicio.categoria === "Web" || servicioData.servicio.categoria === "Soporte web" && ( 
                  <>
                    <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                      <p className="text-xs text-slate-600 whitespace-pre-line">
                        <span className="font-bold">Nombre gerente: </span>{servicioData.cotizacion.cliente.nombreGerente}<br />
                      </p>  
                    </div>

                    <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                      <p className="text-xs text-slate-600 whitespace-pre-line">
                        <span className="font-bold">Número gerente: </span>{servicioData.cotizacion.cliente.telefonoGerente}<br />
                      </p>  
                    </div>

                    <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                      <p className="text-xs text-slate-600 whitespace-pre-line">
                        <span className="font-bold">Nombre encargado: </span>{servicioData.cotizacion.cliente.encargadoProyecto}<br />
                      </p>  
                    </div>

                    <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                      <p className="text-xs text-slate-600 whitespace-pre-line">
                        <span className="font-bold">Número encargado: </span>{servicioData.cotizacion.cliente.telefono}<br />
                      </p>  
                    </div>
                  </>
                )}

                <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                  <p className="text-xs text-slate-600 whitespace-pre-line">
                    <span className="font-bold">Servicio: </span>{servicioData && servicioData?.servicio?.name}<br />
                  </p>  
                </div>

                <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                  <p className="text-xs text-slate-600 whitespace-pre-line">
                    <span className="font-bold">Moneda: </span>{servicioData && servicioData.cotizacion.moneda}<br />
                  </p>  
                </div>

                <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                  <p className="text-xs text-slate-600 whitespace-pre-line">
                    <span className="font-bold">Dias Restantes: </span>                    
                      {formValues.fechaFin &&
                        differenceInDays(
                          new Date(formValues.fechaFin),
                          new Date()
                      )}
                  </p>  
                </div>

                <div className="flex flex-row justify-between items-center rounded bg-gray-100 p-4">
                    <p className="text-xs text-slate-600 whitespace-pre-line"> 
                      <span className="font-bold">Requiere making of </span>
                    </p>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        id={"audiovisuales"}
                        type="checkbox"
                        disabled
                        value={servicioData.produccionAudiovisual}
                        checked={servicioData.produccionAudiovisual}
                        className="sr-only peer"
                      />{" "}
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                    </label> 
                </div>

                <ClientData client={servicioData.cotizacion.cliente} />
              
              </div>

            </div>
          
            {/* Estado */}
            <div className="p-3 shadow border rounded">

              <h3 className="text-sm font-bold text-slate-600 mb-2">Estado</h3>

              <div className="mt-2 w-full">
                <select
                  id={"estado"}
                  value={formValues.estado}
                  disabled={!isAdmin}
                  onChange={(ev) => {
                    if ((!isAdmin || !delayResponsible || delayResponsible === "Por definir" || linkCapacitacion === "") && ev.target.value === "Terminado con exito" && servicioData.servicio.categoria === "Web") {
                      toast.error("Para colocar en estado exito debe completar los campos de responsable retraso y link de capacita ción")
                      return
                    }
                    setFormValues((prev) => ({
                      ...prev,
                      estado: ev.target.value,
                    }))
                  }}
                  className={`text-xs rounded-lg block p-2.5 w-full hover:cursor-pointer ${statusColorMap[formValues.estado] || ""}`}
                >
                  {servicioData.servicio.categoria !== "Web" ? (
                    serviceStatus.map((e, i) => (
                      <option key={i} value={e.value} className={`${e.color}`}>{e.icon} {e.label}</option>

                    ))
                  ) : (
                    webServiceStatus.map((e, i) => (
                      <option key={i} value={e.value} className={`${e.color}`}>{e.icon} {e.label}</option>

                    ))
                  )}
                  {/* {optionsEstado.map((e) => (
                    <option key={e.id} value={e.value}>
                      {e.label}
                    </option>
                  ))} */}
                </select>
              </div>
              
              {servicioData.servicio.categoria !== "Web" ? (
                <>
                  <div className="w-full mt-4 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Presupuesto:
                    </h3>
                    <input
                        type="number"
                        id={"presupuesto"}
                        value={formValues.presupuesto}
                        onChange={(e) =>
                          setFormValues((prev) => ({
                            ...prev,
                            presupuesto: Number(e.target.value),
                          }))
                        }
                        className="w-2/3 border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        required
                      />
                  </div>
              
                  <div className="w-full mt-4 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Gastado:
                    </h3>
                    <input
                        type="number"
                        id={"Gastado"}
                        value={formValues.gastado}
                        onChange={(e) =>
                          setFormValues((prev) => ({
                            ...prev,
                            gastado: Number(e.target.value),
                          }))
                        }
                        className="w-2/3 border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        required
                      />
                  </div>
                </>
              ) : (
                <>
                  {/* Referencia web */}
                  <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Web refer.
                    </h3>
                    <input
                      value={refWeb}
                      onChange={(e) => setRefWeb(e.target.value)}
                      className="w-2/3 border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />

                    {/* Save Button */}
                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white">
                      <IconButton
                        aria-label="save"
                        size="small"
                        color="success"
                        onClick={() => handleUpdateRefWeb(refWeb)}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  </div>

                  {/* Copia seguridad referencia web */}
                  <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Copia seg ref.
                    </h3>
                    <input
                      value={copyWebRef}
                      onChange={(e) => setCopyWebRef(e.target.value)}
                      className="w-2/3 border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />

                    {/* Save Button */}
                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white">
                      <IconButton
                        aria-label="save"
                        size="small"
                        color="success"
                        onClick={() => handleUpdateCopyRefWeb(copyWebRef)}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  </div>

                  {/* Link desarrollo */}
                  {/* <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Link desarrollo.
                    </h3>
                    <input
                      value={linkDesarrollo}
                      onChange={(e) => setLinkDesarrollo(e.target.value)}
                      className="w-2/3 border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />


                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white">
                      <IconButton
                        aria-label="save"
                        size="small"
                        color="success"
                        onClick={() => handleUpdateLinkDesarrollo(linkDesarrollo)}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  </div> */}

                  {/* Link capacitación */}
                  <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Link capacitación.
                    </h3>
                    <input
                      value={linkCapacitacion}
                      onChange={(e) => setLinkCapacitacion(e.target.value)}
                      className="w-2/3 border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />

                    {/* Save Button */}
                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white">
                      <IconButton
                        aria-label="save"
                        size="small"
                        color="success"
                        onClick={() => handleUpdateLinkCapacitacion(linkCapacitacion)}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  </div>

                  {/* Info enviada */}
                  <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Info enviada
                    </h3>
                    <select 
                      name="informacionEnviada" 
                      id="informacionEnviada"
                      className="w-2/3 hover:cursor-pointer border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      value={infoComplete}
                      onChange={(e) => {
                        setInfoComplete(e.target.value)
                        handleUpdateInfoSent(e.target.value)
                      }}
                    >
                      <option value="Por confirmar" className="text-black">Por confirmar</option>
                      <option value="No envió nada" className="text-red-500">No envió nada</option>
                      <option value="Envió poco" className="text-yellow-400">Envió poco</option>
                      <option value="Envió todo" className="text-green-500">Envió todo</option>
                    </select>
                  </div>

                  {/* Capacitación realizada */}
                  <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Capacitación realizada
                    </h3>
                    <select 
                      name="informacionEnviada" 
                      id="informacionEnviada"
                      className="w-2/3 hover:cursor-pointer border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      value={capDone}
                      onChange={(e) => {
                        setCapDone(e.target.value)
                        handleUpdateCapDone(e.target.value)
                      }}
                    >
                      <option value="">Seleccionar</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  {/* Culpable retraso */}
                  <div className="w-full mt-2 bg-gray-100 items-center pl-2 flex border border-gray-100 flex-row rounded-md relative">
                    <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                      Culpable retraso
                    </h3>
                    <select 
                      name="informacionEnviada" 
                      id="informacionEnviada"
                      className="w-2/3 hover:cursor-pointer border-none text-xs rounded-l-none rounded-r-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      value={delayResponsible}
                      onChange={(e) => {
                        setDelayResponsible(e.target.value)
                        handleUpdateDelayResponsible(e.target.value)
                      }}
                    >
                      <option value="Por definir">Por definir</option>
                      <option value="Cliente">Cliente</option>
                      <option value="Agencia">Agencia</option>
                      <option value="No aplica">No aplica</option>
                    </select>
                  </div>
                </>
              )}

              {servicioData.produccionAudiovisual && (
                <div className="flex flex-col gap-3 items-center justify-center mt-4">    
      
                  <LinkProyectoGrabacion s={servicioData} />

                  <LinksProyectoMakingOf s={servicioData} />
                  
                </div>
              )}

            </div>

            {/* Formulario y Link redes */}
            <div className="p-2 flex flex-col gap-2 shadow border rounded">
              
              <div className="flex flex-col gap-2">
                <h3 className="text-sm font-bold text-slate-600 mb-1">Formularios</h3>

                <div className="w-full bg-gray-100 items-center p-2 flex flex-row rounded-md">
                  <h3 className="w-1/3 text-gray-700 text-xs font-semibold">
                    Formulario Entrada
                  </h3>

                  {formulariosList.length > 0 &&
                    formulariosList.some((e) => e.formulario.tipo === "entrada") ? (
                    <div className="flex text-xs flex-row w-full gap-2 items-center justify-between">
                      {formulariosList.find(
                        (y) => y.formulario.tipo === "entrada"
                      ).respondido ? (

                        <Link
                          className="text-blue-600 text-xs bg-blue-700 bg-opacity-10 w-1/2 flex hover:bg-opacity-20 transition-all duration-100 justify-center gap-2 items-center p-2 rounded-md text-xs hover:text-blue-700  font-semibold"
                          to={`/home/seguimiento/encuestas-respuestas/${
                            formulariosList.find(
                              (x) => x.formulario.tipo === "entrada"
                            ).id
                          }`}
                        >
                          Ver Formulario
                          <div>
                            <FaWpforms />
                          </div>
                        </Link>

                      ) : (
                        <div className="p-2 w-2/3 flex text-xs justify-center rounded bg-gray-200 items-center text-blue-600 text-xs">
                          No respondido{" "}
                        </div>
                      )}

                      <button
                        type="button"
                        onClick={() =>
                          eliminarFormulario(
                            formulariosList.find(
                              (x) => x.formulario.tipo === "entrada"
                            ).id
                          )
                        }
                          className="text-red-600 bg-red-700 bg-opacity-10 hover:bg-opacity-20 transition-all duration-100 flex w-1/2 justify-center gap-2 items-center p-2 rounded-md text-xs hover:text-red-700  font-semibold"
                      >
                        Eliminar
                        <div>
                          <FaTimes />
                        </div>
                      </button>
                    </div>
                  ) : (
                    <div className="w-2/3 flex justify-end border-gray-300 rounded-lg">
                      <button
                        type="button"
                        onClick={() => asignarFormulario("entrada")}
                        className="w-[90%] text-gray-700 flex justify-center items-center gap-2 bg-white p-2 rounded-md text-xs font-semibold shadow-md hover:bg-gray-50 transition-all duration-100"
                      >
                        Asignar formulario
                        <div>
                          <FaPlus />
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <h3 className="text-sm font-bold text-slate-600 mb-1">Links</h3>

              <SeguimientoLinks 
                setServicioData={setServicioData} 
                servicioData={servicioData}
              />

              {(servicioData.servicio.categoria === "Web" || servicioData.servicio.categoria === "Software") && ( // Web y Software
                <div className="flex flex-col gap-2">
                  
                  {/* Link web oficial */}
                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                    
                    {/* Título */}
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link web oficial
                      </span>
                    </div>
                  
                    {/* URL */}
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={linkWebOficial.url}
                        //disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) =>
                          setLinkWebOficial((prev) => ({
                            ...prev,
                            url: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
                      />
                    </div>
                    
                    {/* Save */}
                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton 
                        aria-label="delete" 
                        size="small" 
                        color="success"
                        onClick={() => handleSaveLink(linkWebOficial, "Link web oficial")}
                        >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>

                  {/* Link demo */}
                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                    
                    {/* Título */}
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link demo - desarrollo
                      </span>
                    </div>
                  
                    {/* URL */}
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={linkDemo.url}
                        //disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) =>
                          setLinkDemo((prev) => ({
                            ...prev,
                            url: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
                      />
                    </div>
                    
                    {/* Save */}
                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton
                        size="small" 
                        color="success"
                        onClick={() => handleSaveLink(linkDemo, "Link demo")}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>
                  
                  {/* Link backup */}
                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                    
                    {/* Título */}
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link backup
                      </span>
                    </div>
                  
                    {/* URL */}
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={linkBackup.url}
                        //disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) =>
                          setLinkBackup((prev) => ({
                            ...prev,
                            url: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                      />
                    </div>
                    
                    {/* Save */}
                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton 
                        size="small" 
                        color="success"
                        onClick={() => handleSaveLink(linkBackup, "Link backup")}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>
  
                </div>
              )}

              {servicioData.servicio.categoria === "Soporte web" && ( // Solo Soporte web
                <div className="flex flex-col gap-2">

                  {/* Link web oficial */}
                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                    
                    {/* Título */}
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link web oficial
                      </span>
                    </div>
                  
                    {/* URL */}
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={linkWebOficial.url}
                        //disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) =>
                          setLinkWebOficial((prev) => ({
                            ...prev,
                            url: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
                      />
                    </div>
                    
                    {/* Save */}
                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton 
                        aria-label="delete" 
                        size="small" 
                        color="success"
                        onClick={() => handleSaveLink(linkWebOficial, "Link web oficial")}
                        >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>

                </div>
              )}

              {(servicioData.servicio.categoria === "Web" && servicioData.servicio.id === "6577752ac1c6ac85e69c86ed") && ( // Solo aulas virtuales
                <DemoAccessBox
                  serviceId={servicioData.id}
                />
              )}

              {(servicioData.servicio.id === "66cfd3fc5a0dab807ba0c2af") && ( // Solo webs en código
                <CredentialsBox 
                  serviceId={servicioData.id}
                />
              )}

              {servicioData.servicio.categoria === "ADS" && ( // Solo ADS
                <div className="flex flex-col gap-2">
                  
                  {/* Link web oficial */}
                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                    
                    {/* Título */}
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link web oficial
                      </span>
                    </div>
                  
                    {/* URL */}
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={linkWebOficial.url}
                        //disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) =>
                          setLinkWebOficial((prev) => ({
                            ...prev,
                            url: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
                      />
                    </div>
                    
                    {/* Save */}
                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton 
                        aria-label="delete" 
                        size="small" 
                        color="success"
                        onClick={() => handleSaveLink(linkWebOficial, "Link web oficial")}
                        >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>
  
                </div>
              )}

              <SeguimientoActionPanel
                servicioData={servicioData} 
                setServicioData={setServicioData}
              />

              {/* {servicioData.servicio.categoria === "ADS" && ( // Solo ADS
                <div className="flex flex-col gap-2">

                  <div className="flex flex-row w-full items-center justify-center text-xs text-gray-700">
                    <span className="w-[30%] px-4 text-center">Nombre</span>
                    <span className="w-[60%] px-4 text-center">Link</span>
                    <div className="w-[10%] flex justify-center items-center px-4">
                      <SaveIcon fontSize="small" />
                    </div>
                  </div>
                  

                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                     
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link plan de trabajo
                      </span>
                    </div>
                  
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={servicioData.linkPlanTrabajo}
                        //disabled={userStatus !== "SuperAdmin"}
                        onChange={(e) =>
                          setServicioData((prev) => ({
                            ...prev,
                            linkPlanTrabajo: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
                      />
                    </div>

                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton 
                        aria-label="delete" 
                        size="small" 
                        color="success"
                        onClick={() => handleSaveAdsLinks(servicioData.linkPlanTrabajo, "linkPlanTrabajo")}
                        >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>

    
                  <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
                    
                    <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <span className="text-xs font-medium text-gray-700 break-words">
                        Link recursos
                      </span>
                    </div>
                  
                    <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
                      <input
                        value={servicioData.linkRecursos}
                        onChange={(e) =>
                          setServicioData((prev) => ({
                            ...prev,
                            linkRecursos: e.target.value,
                          }))
                        }
                        className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
                      />
                    </div>
                    
                    <div className="w-[10%] flex justify-center items-center px-2 py-2">
                      <IconButton
                        size="small" 
                        color="success"
                        onClick={() => handleSaveAdsLinks(servicioData.linkRecursos, "linkRecursos")}
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    </div>

                  </div>
                  
    
                  <LinksReportesAds
                    serviceId={servicioData.id}
                  />

                </div>
              )} */}
              
            </div>

            <div className="md:col-span-3 flex justify-center">
              <button
                type="button"
                onClick={updateServicio}
                className=" max-w-xs w-full p-2 rounded-md  font-semibold text-white bg-[#FF6400] hover:bg-orange-600"
              >
                Guardar
              </button>
            </div>

          </div>
        </div>
      )}

      {activeTab.id === tabs[3].id && (
        <SeguimientoFormularioScreen
          serviceId={serviceId}
        />
      )}

      {activeTab.id === tabs[4].id && (
        <CalendarioSeguimientoTareas
          tasks={tasks.filter((t) => t.status === "Finalizado" || t.status === "Con retraso")}
        />
      )}

      {activeTab.id === tabs[5].id && (
        <LlamadasSeguimiento
          isAdmin={isAdmin}
          userArea={user.area}
          userId={user.id}
          serviceQuoteId={servicioData.cotizacion.id}
          clientData={servicioData.cotizacion?.cliente}
        />
      )}

      <NuevoLinkServicioDetailsDialog
        idServicio={id}
        refetch={fetchLinksServicios}
        subarea={servicioData.subarea}
        open={nuevoLinkOpen}
        onClose={() => setNuevoLinkOpen(false)}
        title={"Nuevo link"}
      />
       
    </div>
  );
};

export default SeguimientoDetails;